/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * Api
 * POS Inventory Management API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddGiftRegistryItemRequest,
  AdminManualSubscriptionDateCorrection,
  AdminManualSubscriptionInput,
  AdminStore,
  AdminStoreUpdate,
  AdminStoreUpdateResponse,
  BankReconciliationCandidateList,
  BankReconciliationImport,
  BankReconciliationImportInput,
  BankReconciliationImportList,
  BankReconciliationMatchInput,
  BankReconciliationReviewInput,
  BankReconciliationTransaction,
  BankReconciliationTransactionList,
  BudgetOverview,
  BudgetTargetInput,
  BudgetVariance,
  BusinessSubscriptionDiscount,
  BusinessSubscriptionDiscountInput,
  Category,
  CategoryInput,
  CategoryUpdate,
  CreateGiftRegistryRequest,
  CustomerInvoice,
  CustomerInvoiceDetail,
  CustomerInvoiceReminder,
  CustomerInvoiceReminderRequest,
  CustomerInvoiceUpdate,
  CustomerInvoicesResponse,
  DailyCloseReport,
  DashboardSummary,
  DeleteGiftRegistry200,
  DeleteGiftRegistryItem200,
  EmailChangeConfirmed,
  EmailChangeRequestInput,
  EmailChangeRequested,
  EmailChangeVerifyInput,
  EmailPreferences,
  EmailPreferencesUpdate,
  EmailUnsubscribeInput,
  EmailUnsubscribeResult,
  ErrorEnvelope,
  Expense,
  ExpenseBreakdown,
  ExpenseInput,
  ExpenseUpdate,
  ExportCustomerInvoicesParams,
  GetDailyCloseParams,
  GetDashboardSummaryParams,
  GetExpenseBreakdownParams,
  GetLatestProductImportJob200,
  GetProductSalesReportParams,
  GetProfitLossParams,
  GetSalesChartParams,
  GetSchoolFeeSummaryParams,
  GetTopProductsParams,
  GiftRegistry,
  GiftRegistryDetail,
  GiftRegistryItem,
  HealthStatus,
  InitializeSubscription200,
  ListBudgetOverviewParams,
  ListCustomerInvoicesParams,
  ListExpensesParams,
  ListGiftRegistriesParams,
  ListProductsParams,
  ListPurchasesParams,
  ListSalesPageParams,
  ListSalesParams,
  ListSchoolFeeRemindersParams,
  ListSchoolFeeSchedulesParams,
  ListSchoolStudentsParams,
  ListStaffParams,
  PartnerAdCampaignInput,
  PartnerAdCampaignReview,
  PartnerAdCampaignSummary,
  PartnerAdEventInput,
  PartnerAdEventResult,
  PartnerAdModerationItem,
  PartnerAdPreferences,
  PartnerAdPreferencesUpdate,
  PartnerAdsDashboard,
  Product,
  ProductImportBarcodePreview,
  ProductImportBarcodePreviewInput,
  ProductImportJob,
  ProductImportJobInput,
  ProductInput,
  ProductSalesReportResponse,
  ProductUpdate,
  ProfitLossReport,
  Purchase,
  PurchaseDetail,
  PurchaseInput,
  PurchaseUpdate,
  ReceiptEmailRequest,
  ReceiptEmailStatus,
  RecordSalePaymentInput,
  RecordSalePaymentResult,
  Return,
  ReturnInput,
  Sale,
  SaleDetail,
  SaleInput,
  SalesChartPoint,
  SalesPage,
  SchoolFeeAdjustment,
  SchoolFeeAdjustmentInput,
  SchoolFeeCharge,
  SchoolFeeChargeInput,
  SchoolFeePayment,
  SchoolFeePaymentInput,
  SchoolFeeReminderList,
  SchoolFeeReminderSendResult,
  SchoolFeeReminderSettings,
  SchoolFeeReminderSettingsInput,
  SchoolFeeSchedule,
  SchoolFeeScheduleApplyResponse,
  SchoolFeeScheduleInput,
  SchoolFeeScheduleUpdate,
  SchoolFeeStatement,
  SchoolFeeSummary,
  SchoolGuardian,
  SchoolGuardianInput,
  SchoolStudent,
  SchoolStudentInput,
  SchoolStudentListResponse,
  SchoolStudentProfile,
  SchoolStudentRosterImportInput,
  SchoolStudentRosterImportResponse,
  SchoolStudentRosterPreviewResponse,
  SchoolStudentUpdate,
  SchoolTerm,
  SchoolTermInput,
  SchoolTermUpdate,
  StaffInput,
  StaffMember,
  StaffUpdate,
  SubscriptionCheckoutInput,
  SubscriptionPriceQuote,
  Supplier,
  SupplierBill,
  SupplierBillDetail,
  SupplierBillInput,
  SupplierBillList,
  SupplierBillPaymentInput,
  SupplierBillReceiptInput,
  SupplierInput,
  SupplierUpdate,
  TopProduct,
  UpdateGiftRegistryItemRequest,
  UpdateSaleInput,
  UploadUrlRequest,
  UploadUrlResponse
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetPartnerAdsDashboardUrl = () => {




  return `/api/partner-ads/dashboard`
}

/**
 * @summary Get offers and campaign data for the authenticated store
 */
export const getPartnerAdsDashboard = async ( options?: RequestInit): Promise<PartnerAdsDashboard> => {

  return customFetch<PartnerAdsDashboard>(getGetPartnerAdsDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPartnerAdsDashboardQueryKey = () => {
    return [
    `/api/partner-ads/dashboard`
    ] as const;
    }


export const getGetPartnerAdsDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getPartnerAdsDashboard>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPartnerAdsDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPartnerAdsDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnerAdsDashboard>>> = ({ signal }) => getPartnerAdsDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPartnerAdsDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPartnerAdsDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getPartnerAdsDashboard>>>
export type GetPartnerAdsDashboardQueryError = ErrorType<void>


/**
 * @summary Get offers and campaign data for the authenticated store
 */

export function useGetPartnerAdsDashboard<TData = Awaited<ReturnType<typeof getPartnerAdsDashboard>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPartnerAdsDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPartnerAdsDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdatePartnerAdPreferencesUrl = () => {




  return `/api/partner-ads/preferences`
}

/**
 * @summary Set whether the store participates and which advertiser categories it blocks
 */
export const updatePartnerAdPreferences = async (partnerAdPreferencesUpdate: PartnerAdPreferencesUpdate, options?: RequestInit): Promise<PartnerAdPreferences> => {

  return customFetch<PartnerAdPreferences>(getUpdatePartnerAdPreferencesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(partnerAdPreferencesUpdate)
  }
);}




export const getUpdatePartnerAdPreferencesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePartnerAdPreferences>>, TError,{data: BodyType<PartnerAdPreferencesUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePartnerAdPreferences>>, TError,{data: BodyType<PartnerAdPreferencesUpdate>}, TContext> => {

const mutationKey = ['updatePartnerAdPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePartnerAdPreferences>>, {data: BodyType<PartnerAdPreferencesUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updatePartnerAdPreferences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePartnerAdPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof updatePartnerAdPreferences>>>
    export type UpdatePartnerAdPreferencesMutationBody = BodyType<PartnerAdPreferencesUpdate>
    export type UpdatePartnerAdPreferencesMutationError = ErrorType<void>

    /**
 * @summary Set whether the store participates and which advertiser categories it blocks
 */
export const useUpdatePartnerAdPreferences = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePartnerAdPreferences>>, TError,{data: BodyType<PartnerAdPreferencesUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePartnerAdPreferences>>,
        TError,
        {data: BodyType<PartnerAdPreferencesUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePartnerAdPreferencesMutationOptions(options));
    }

export const getCreatePartnerAdCampaignUrl = () => {




  return `/api/partner-ads/campaigns`
}

/**
 * @summary Submit a partner offer for review
 */
export const createPartnerAdCampaign = async (partnerAdCampaignInput: PartnerAdCampaignInput, options?: RequestInit): Promise<PartnerAdCampaignSummary> => {

  return customFetch<PartnerAdCampaignSummary>(getCreatePartnerAdCampaignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(partnerAdCampaignInput)
  }
);}




export const getCreatePartnerAdCampaignMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPartnerAdCampaign>>, TError,{data: BodyType<PartnerAdCampaignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPartnerAdCampaign>>, TError,{data: BodyType<PartnerAdCampaignInput>}, TContext> => {

const mutationKey = ['createPartnerAdCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPartnerAdCampaign>>, {data: BodyType<PartnerAdCampaignInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPartnerAdCampaign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePartnerAdCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof createPartnerAdCampaign>>>
    export type CreatePartnerAdCampaignMutationBody = BodyType<PartnerAdCampaignInput>
    export type CreatePartnerAdCampaignMutationError = ErrorType<void>

    /**
 * @summary Submit a partner offer for review
 */
export const useCreatePartnerAdCampaign = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPartnerAdCampaign>>, TError,{data: BodyType<PartnerAdCampaignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPartnerAdCampaign>>,
        TError,
        {data: BodyType<PartnerAdCampaignInput>},
        TContext
      > => {
      return useMutation(getCreatePartnerAdCampaignMutationOptions(options));
    }

export const getListPartnerAdCampaignsUrl = () => {




  return `/api/partner-ads/campaigns`
}

/**
 * @summary List campaigns submitted by the authenticated store
 */
export const listPartnerAdCampaigns = async ( options?: RequestInit): Promise<PartnerAdCampaignSummary[]> => {

  return customFetch<PartnerAdCampaignSummary[]>(getListPartnerAdCampaignsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPartnerAdCampaignsQueryKey = () => {
    return [
    `/api/partner-ads/campaigns`
    ] as const;
    }


export const getListPartnerAdCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof listPartnerAdCampaigns>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPartnerAdCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPartnerAdCampaignsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPartnerAdCampaigns>>> = ({ signal }) => listPartnerAdCampaigns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPartnerAdCampaigns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPartnerAdCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof listPartnerAdCampaigns>>>
export type ListPartnerAdCampaignsQueryError = ErrorType<void>


/**
 * @summary List campaigns submitted by the authenticated store
 */

export function useListPartnerAdCampaigns<TData = Awaited<ReturnType<typeof listPartnerAdCampaigns>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPartnerAdCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPartnerAdCampaignsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getTrackPartnerAdEventUrl = (campaignId: number,) => {




  return `/api/partner-ads/campaigns/${campaignId}/events`
}

/**
 * @summary Record a once-per-store-per-day view or click
 */
export const trackPartnerAdEvent = async (campaignId: number,
    partnerAdEventInput: PartnerAdEventInput, options?: RequestInit): Promise<PartnerAdEventResult> => {

  return customFetch<PartnerAdEventResult>(getTrackPartnerAdEventUrl(campaignId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(partnerAdEventInput)
  }
);}




export const getTrackPartnerAdEventMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trackPartnerAdEvent>>, TError,{campaignId: number;data: BodyType<PartnerAdEventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof trackPartnerAdEvent>>, TError,{campaignId: number;data: BodyType<PartnerAdEventInput>}, TContext> => {

const mutationKey = ['trackPartnerAdEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof trackPartnerAdEvent>>, {campaignId: number;data: BodyType<PartnerAdEventInput>}> = (props) => {
          const {campaignId,data} = props ?? {};

          return  trackPartnerAdEvent(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TrackPartnerAdEventMutationResult = NonNullable<Awaited<ReturnType<typeof trackPartnerAdEvent>>>
    export type TrackPartnerAdEventMutationBody = BodyType<PartnerAdEventInput>
    export type TrackPartnerAdEventMutationError = ErrorType<void>

    /**
 * @summary Record a once-per-store-per-day view or click
 */
export const useTrackPartnerAdEvent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trackPartnerAdEvent>>, TError,{campaignId: number;data: BodyType<PartnerAdEventInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof trackPartnerAdEvent>>,
        TError,
        {campaignId: number;data: BodyType<PartnerAdEventInput>},
        TContext
      > => {
      return useMutation(getTrackPartnerAdEventMutationOptions(options));
    }

export const getListAdminPartnerAdCampaignsUrl = () => {




  return `/api/admin/partner-ad-campaigns`
}

/**
 * @summary List partner ad campaigns for moderation
 */
export const listAdminPartnerAdCampaigns = async ( options?: RequestInit): Promise<PartnerAdModerationItem[]> => {

  return customFetch<PartnerAdModerationItem[]>(getListAdminPartnerAdCampaignsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminPartnerAdCampaignsQueryKey = () => {
    return [
    `/api/admin/partner-ad-campaigns`
    ] as const;
    }


export const getListAdminPartnerAdCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminPartnerAdCampaigns>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminPartnerAdCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminPartnerAdCampaignsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminPartnerAdCampaigns>>> = ({ signal }) => listAdminPartnerAdCampaigns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminPartnerAdCampaigns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminPartnerAdCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminPartnerAdCampaigns>>>
export type ListAdminPartnerAdCampaignsQueryError = ErrorType<void>


/**
 * @summary List partner ad campaigns for moderation
 */

export function useListAdminPartnerAdCampaigns<TData = Awaited<ReturnType<typeof listAdminPartnerAdCampaigns>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminPartnerAdCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminPartnerAdCampaignsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getReviewPartnerAdCampaignUrl = (campaignId: number,) => {




  return `/api/admin/partner-ad-campaigns/${campaignId}`
}

/**
 * @summary Approve or reject a submitted partner ad
 */
export const reviewPartnerAdCampaign = async (campaignId: number,
    partnerAdCampaignReview: PartnerAdCampaignReview, options?: RequestInit): Promise<PartnerAdModerationItem> => {

  return customFetch<PartnerAdModerationItem>(getReviewPartnerAdCampaignUrl(campaignId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(partnerAdCampaignReview)
  }
);}




export const getReviewPartnerAdCampaignMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewPartnerAdCampaign>>, TError,{campaignId: number;data: BodyType<PartnerAdCampaignReview>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewPartnerAdCampaign>>, TError,{campaignId: number;data: BodyType<PartnerAdCampaignReview>}, TContext> => {

const mutationKey = ['reviewPartnerAdCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewPartnerAdCampaign>>, {campaignId: number;data: BodyType<PartnerAdCampaignReview>}> = (props) => {
          const {campaignId,data} = props ?? {};

          return  reviewPartnerAdCampaign(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewPartnerAdCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof reviewPartnerAdCampaign>>>
    export type ReviewPartnerAdCampaignMutationBody = BodyType<PartnerAdCampaignReview>
    export type ReviewPartnerAdCampaignMutationError = ErrorType<void>

    /**
 * @summary Approve or reject a submitted partner ad
 */
export const useReviewPartnerAdCampaign = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewPartnerAdCampaign>>, TError,{campaignId: number;data: BodyType<PartnerAdCampaignReview>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviewPartnerAdCampaign>>,
        TError,
        {campaignId: number;data: BodyType<PartnerAdCampaignReview>},
        TContext
      > => {
      return useMutation(getReviewPartnerAdCampaignMutationOptions(options));
    }

export const getListAdminStoresUrl = () => {




  return `/api/admin/stores`
}

/**
 * @summary List stores with their POS product counts
 */
export const listAdminStores = async ( options?: RequestInit): Promise<AdminStore[]> => {

  return customFetch<AdminStore[]>(getListAdminStoresUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminStoresQueryKey = () => {
    return [
    `/api/admin/stores`
    ] as const;
    }


export const getListAdminStoresQueryOptions = <TData = Awaited<ReturnType<typeof listAdminStores>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminStores>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminStoresQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminStores>>> = ({ signal }) => listAdminStores({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminStores>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminStoresQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminStores>>>
export type ListAdminStoresQueryError = ErrorType<void>


/**
 * @summary List stores with their POS product counts
 */

export function useListAdminStores<TData = Awaited<ReturnType<typeof listAdminStores>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminStores>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminStoresQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateAdminStoreUrl = (storeId: number,) => {




  return `/api/admin/stores/${storeId}`
}

/**
 * @summary Update a store's plan or administrative status
 */
export const updateAdminStore = async (storeId: number,
    adminStoreUpdate: AdminStoreUpdate, options?: RequestInit): Promise<AdminStoreUpdateResponse> => {

  return customFetch<AdminStoreUpdateResponse>(getUpdateAdminStoreUrl(storeId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminStoreUpdate)
  }
);}




export const getUpdateAdminStoreMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminStore>>, TError,{storeId: number;data: BodyType<AdminStoreUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminStore>>, TError,{storeId: number;data: BodyType<AdminStoreUpdate>}, TContext> => {

const mutationKey = ['updateAdminStore'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminStore>>, {storeId: number;data: BodyType<AdminStoreUpdate>}> = (props) => {
          const {storeId,data} = props ?? {};

          return  updateAdminStore(storeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminStoreMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminStore>>>
    export type UpdateAdminStoreMutationBody = BodyType<AdminStoreUpdate>
    export type UpdateAdminStoreMutationError = ErrorType<void>

    /**
 * @summary Update a store's plan or administrative status
 */
export const useUpdateAdminStore = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminStore>>, TError,{storeId: number;data: BodyType<AdminStoreUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminStore>>,
        TError,
        {storeId: number;data: BodyType<AdminStoreUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAdminStoreMutationOptions(options));
    }

export const getRecordAdminManualSubscriptionUrl = (storeId: number,) => {




  return `/api/admin/stores/${storeId}/manual-subscription`
}

/**
 * @summary Record a bank-transfer subscription payment
 */
export const recordAdminManualSubscription = async (storeId: number,
    adminManualSubscriptionInput: AdminManualSubscriptionInput, options?: RequestInit): Promise<AdminStoreUpdateResponse> => {

  return customFetch<AdminStoreUpdateResponse>(getRecordAdminManualSubscriptionUrl(storeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminManualSubscriptionInput)
  }
);}




export const getRecordAdminManualSubscriptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAdminManualSubscription>>, TError,{storeId: number;data: BodyType<AdminManualSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordAdminManualSubscription>>, TError,{storeId: number;data: BodyType<AdminManualSubscriptionInput>}, TContext> => {

const mutationKey = ['recordAdminManualSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordAdminManualSubscription>>, {storeId: number;data: BodyType<AdminManualSubscriptionInput>}> = (props) => {
          const {storeId,data} = props ?? {};

          return  recordAdminManualSubscription(storeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordAdminManualSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof recordAdminManualSubscription>>>
    export type RecordAdminManualSubscriptionMutationBody = BodyType<AdminManualSubscriptionInput>
    export type RecordAdminManualSubscriptionMutationError = ErrorType<void>

    /**
 * @summary Record a bank-transfer subscription payment
 */
export const useRecordAdminManualSubscription = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAdminManualSubscription>>, TError,{storeId: number;data: BodyType<AdminManualSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordAdminManualSubscription>>,
        TError,
        {storeId: number;data: BodyType<AdminManualSubscriptionInput>},
        TContext
      > => {
      return useMutation(getRecordAdminManualSubscriptionMutationOptions(options));
    }

export const getCorrectAdminManualSubscriptionDatesUrl = (storeId: number,) => {




  return `/api/admin/stores/${storeId}/manual-subscription`
}

/**
 * @summary Correct dates on the latest manual subscription without recording another payment
 */
export const correctAdminManualSubscriptionDates = async (storeId: number,
    adminManualSubscriptionDateCorrection: AdminManualSubscriptionDateCorrection, options?: RequestInit): Promise<AdminStoreUpdateResponse> => {

  return customFetch<AdminStoreUpdateResponse>(getCorrectAdminManualSubscriptionDatesUrl(storeId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminManualSubscriptionDateCorrection)
  }
);}




export const getCorrectAdminManualSubscriptionDatesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctAdminManualSubscriptionDates>>, TError,{storeId: number;data: BodyType<AdminManualSubscriptionDateCorrection>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof correctAdminManualSubscriptionDates>>, TError,{storeId: number;data: BodyType<AdminManualSubscriptionDateCorrection>}, TContext> => {

const mutationKey = ['correctAdminManualSubscriptionDates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof correctAdminManualSubscriptionDates>>, {storeId: number;data: BodyType<AdminManualSubscriptionDateCorrection>}> = (props) => {
          const {storeId,data} = props ?? {};

          return  correctAdminManualSubscriptionDates(storeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CorrectAdminManualSubscriptionDatesMutationResult = NonNullable<Awaited<ReturnType<typeof correctAdminManualSubscriptionDates>>>
    export type CorrectAdminManualSubscriptionDatesMutationBody = BodyType<AdminManualSubscriptionDateCorrection>
    export type CorrectAdminManualSubscriptionDatesMutationError = ErrorType<void>

    /**
 * @summary Correct dates on the latest manual subscription without recording another payment
 */
export const useCorrectAdminManualSubscriptionDates = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctAdminManualSubscriptionDates>>, TError,{storeId: number;data: BodyType<AdminManualSubscriptionDateCorrection>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof correctAdminManualSubscriptionDates>>,
        TError,
        {storeId: number;data: BodyType<AdminManualSubscriptionDateCorrection>},
        TContext
      > => {
      return useMutation(getCorrectAdminManualSubscriptionDatesMutationOptions(options));
    }

export const getListAdminSubscriptionDiscountsUrl = () => {




  return `/api/admin/subscription-discounts`
}

/**
 * @summary List the latest subscription discount offer for each business
 */
export const listAdminSubscriptionDiscounts = async ( options?: RequestInit): Promise<BusinessSubscriptionDiscount[]> => {

  return customFetch<BusinessSubscriptionDiscount[]>(getListAdminSubscriptionDiscountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminSubscriptionDiscountsQueryKey = () => {
    return [
    `/api/admin/subscription-discounts`
    ] as const;
    }


export const getListAdminSubscriptionDiscountsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminSubscriptionDiscounts>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminSubscriptionDiscounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminSubscriptionDiscountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminSubscriptionDiscounts>>> = ({ signal }) => listAdminSubscriptionDiscounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminSubscriptionDiscounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminSubscriptionDiscountsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminSubscriptionDiscounts>>>
export type ListAdminSubscriptionDiscountsQueryError = ErrorType<void>


/**
 * @summary List the latest subscription discount offer for each business
 */

export function useListAdminSubscriptionDiscounts<TData = Awaited<ReturnType<typeof listAdminSubscriptionDiscounts>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminSubscriptionDiscounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminSubscriptionDiscountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSetAdminSubscriptionDiscountUrl = (storeId: number,) => {




  return `/api/admin/stores/${storeId}/subscription-discount`
}

/**
 * @summary Create a new business-specific subscription offer
 */
export const setAdminSubscriptionDiscount = async (storeId: number,
    businessSubscriptionDiscountInput: BusinessSubscriptionDiscountInput, options?: RequestInit): Promise<BusinessSubscriptionDiscount> => {

  return customFetch<BusinessSubscriptionDiscount>(getSetAdminSubscriptionDiscountUrl(storeId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(businessSubscriptionDiscountInput)
  }
);}




export const getSetAdminSubscriptionDiscountMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminSubscriptionDiscount>>, TError,{storeId: number;data: BodyType<BusinessSubscriptionDiscountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdminSubscriptionDiscount>>, TError,{storeId: number;data: BodyType<BusinessSubscriptionDiscountInput>}, TContext> => {

const mutationKey = ['setAdminSubscriptionDiscount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminSubscriptionDiscount>>, {storeId: number;data: BodyType<BusinessSubscriptionDiscountInput>}> = (props) => {
          const {storeId,data} = props ?? {};

          return  setAdminSubscriptionDiscount(storeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminSubscriptionDiscountMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminSubscriptionDiscount>>>
    export type SetAdminSubscriptionDiscountMutationBody = BodyType<BusinessSubscriptionDiscountInput>
    export type SetAdminSubscriptionDiscountMutationError = ErrorType<void>

    /**
 * @summary Create a new business-specific subscription offer
 */
export const useSetAdminSubscriptionDiscount = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminSubscriptionDiscount>>, TError,{storeId: number;data: BodyType<BusinessSubscriptionDiscountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAdminSubscriptionDiscount>>,
        TError,
        {storeId: number;data: BodyType<BusinessSubscriptionDiscountInput>},
        TContext
      > => {
      return useMutation(getSetAdminSubscriptionDiscountMutationOptions(options));
    }

export const getEndAdminSubscriptionDiscountUrl = (storeId: number,) => {




  return `/api/admin/stores/${storeId}/subscription-discount`
}

/**
 * @summary Stop new discounted checkouts without changing completed purchases
 */
export const endAdminSubscriptionDiscount = async (storeId: number, options?: RequestInit): Promise<BusinessSubscriptionDiscount> => {

  return customFetch<BusinessSubscriptionDiscount>(getEndAdminSubscriptionDiscountUrl(storeId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getEndAdminSubscriptionDiscountMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endAdminSubscriptionDiscount>>, TError,{storeId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof endAdminSubscriptionDiscount>>, TError,{storeId: number}, TContext> => {

const mutationKey = ['endAdminSubscriptionDiscount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endAdminSubscriptionDiscount>>, {storeId: number}> = (props) => {
          const {storeId} = props ?? {};

          return  endAdminSubscriptionDiscount(storeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EndAdminSubscriptionDiscountMutationResult = NonNullable<Awaited<ReturnType<typeof endAdminSubscriptionDiscount>>>

    export type EndAdminSubscriptionDiscountMutationError = ErrorType<void>

    /**
 * @summary Stop new discounted checkouts without changing completed purchases
 */
export const useEndAdminSubscriptionDiscount = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endAdminSubscriptionDiscount>>, TError,{storeId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof endAdminSubscriptionDiscount>>,
        TError,
        {storeId: number},
        TContext
      > => {
      return useMutation(getEndAdminSubscriptionDiscountMutationOptions(options));
    }

export const getGetSubscriptionPricingUrl = () => {




  return `/api/subscriptions/pricing`
}

/**
 * @summary Show subscription prices for the current business, including its available offer
 */
export const getSubscriptionPricing = async ( options?: RequestInit): Promise<SubscriptionPriceQuote[]> => {

  return customFetch<SubscriptionPriceQuote[]>(getGetSubscriptionPricingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSubscriptionPricingQueryKey = () => {
    return [
    `/api/subscriptions/pricing`
    ] as const;
    }


export const getGetSubscriptionPricingQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionPricing>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPricing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionPricingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionPricing>>> = ({ signal }) => getSubscriptionPricing({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPricing>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionPricingQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionPricing>>>
export type GetSubscriptionPricingQueryError = ErrorType<void>


/**
 * @summary Show subscription prices for the current business, including its available offer
 */

export function useGetSubscriptionPricing<TData = Awaited<ReturnType<typeof getSubscriptionPricing>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPricing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSubscriptionPricingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getInitializeSubscriptionUrl = () => {




  return `/api/subscriptions/initialize`
}

/**
 * @summary Start a Paystack subscription checkout at the quoted price
 */
export const initializeSubscription = async (subscriptionCheckoutInput: SubscriptionCheckoutInput, options?: RequestInit): Promise<InitializeSubscription200> => {

  return customFetch<InitializeSubscription200>(getInitializeSubscriptionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(subscriptionCheckoutInput)
  }
);}




export const getInitializeSubscriptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeSubscription>>, TError,{data: BodyType<SubscriptionCheckoutInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof initializeSubscription>>, TError,{data: BodyType<SubscriptionCheckoutInput>}, TContext> => {

const mutationKey = ['initializeSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initializeSubscription>>, {data: BodyType<SubscriptionCheckoutInput>}> = (props) => {
          const {data} = props ?? {};

          return  initializeSubscription(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitializeSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof initializeSubscription>>>
    export type InitializeSubscriptionMutationBody = BodyType<SubscriptionCheckoutInput>
    export type InitializeSubscriptionMutationError = ErrorType<void>

    /**
 * @summary Start a Paystack subscription checkout at the quoted price
 */
export const useInitializeSubscription = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeSubscription>>, TError,{data: BodyType<SubscriptionCheckoutInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof initializeSubscription>>,
        TError,
        {data: BodyType<SubscriptionCheckoutInput>},
        TContext
      > => {
      return useMutation(getInitializeSubscriptionMutationOptions(options));
    }

export const getGetEmailPreferencesUrl = () => {




  return `/api/auth/email-preferences`
}

/**
 * @summary Get the current user's optional email preferences
 */
export const getEmailPreferences = async ( options?: RequestInit): Promise<EmailPreferences> => {

  return customFetch<EmailPreferences>(getGetEmailPreferencesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEmailPreferencesQueryKey = () => {
    return [
    `/api/auth/email-preferences`
    ] as const;
    }


export const getGetEmailPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getEmailPreferences>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmailPreferences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailPreferences>>> = ({ signal }) => getEmailPreferences({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailPreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmailPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailPreferences>>>
export type GetEmailPreferencesQueryError = ErrorType<void>


/**
 * @summary Get the current user's optional email preferences
 */

export function useGetEmailPreferences<TData = Awaited<ReturnType<typeof getEmailPreferences>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmailPreferences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmailPreferencesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateEmailPreferencesUrl = () => {




  return `/api/auth/email-preferences`
}

/**
 * @summary Change the current user's optional email preferences
 */
export const updateEmailPreferences = async (emailPreferencesUpdate: EmailPreferencesUpdate, options?: RequestInit): Promise<EmailPreferences> => {

  return customFetch<EmailPreferences>(getUpdateEmailPreferencesUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailPreferencesUpdate)
  }
);}




export const getUpdateEmailPreferencesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailPreferences>>, TError,{data: BodyType<EmailPreferencesUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmailPreferences>>, TError,{data: BodyType<EmailPreferencesUpdate>}, TContext> => {

const mutationKey = ['updateEmailPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmailPreferences>>, {data: BodyType<EmailPreferencesUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateEmailPreferences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmailPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmailPreferences>>>
    export type UpdateEmailPreferencesMutationBody = BodyType<EmailPreferencesUpdate>
    export type UpdateEmailPreferencesMutationError = ErrorType<void>

    /**
 * @summary Change the current user's optional email preferences
 */
export const useUpdateEmailPreferences = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailPreferences>>, TError,{data: BodyType<EmailPreferencesUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateEmailPreferences>>,
        TError,
        {data: BodyType<EmailPreferencesUpdate>},
        TContext
      > => {
      return useMutation(getUpdateEmailPreferencesMutationOptions(options));
    }

export const getRequestEmailChangeUrl = () => {




  return `/api/auth/email-change/request`
}

/**
 * @summary Verify a new sign-in and store contact email before changing both
 */
export const requestEmailChange = async (emailChangeRequestInput: EmailChangeRequestInput, options?: RequestInit): Promise<EmailChangeRequested> => {

  return customFetch<EmailChangeRequested>(getRequestEmailChangeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailChangeRequestInput)
  }
);}




export const getRequestEmailChangeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestEmailChange>>, TError,{data: BodyType<EmailChangeRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestEmailChange>>, TError,{data: BodyType<EmailChangeRequestInput>}, TContext> => {

const mutationKey = ['requestEmailChange'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestEmailChange>>, {data: BodyType<EmailChangeRequestInput>}> = (props) => {
          const {data} = props ?? {};

          return  requestEmailChange(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestEmailChangeMutationResult = NonNullable<Awaited<ReturnType<typeof requestEmailChange>>>
    export type RequestEmailChangeMutationBody = BodyType<EmailChangeRequestInput>
    export type RequestEmailChangeMutationError = ErrorType<void>

    /**
 * @summary Verify a new sign-in and store contact email before changing both
 */
export const useRequestEmailChange = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestEmailChange>>, TError,{data: BodyType<EmailChangeRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestEmailChange>>,
        TError,
        {data: BodyType<EmailChangeRequestInput>},
        TContext
      > => {
      return useMutation(getRequestEmailChangeMutationOptions(options));
    }

export const getVerifyEmailChangeUrl = () => {




  return `/api/auth/email-change/verify`
}

/**
 * @summary Confirm the code and update the sign-in and store contact emails
 */
export const verifyEmailChange = async (emailChangeVerifyInput: EmailChangeVerifyInput, options?: RequestInit): Promise<EmailChangeConfirmed> => {

  return customFetch<EmailChangeConfirmed>(getVerifyEmailChangeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailChangeVerifyInput)
  }
);}




export const getVerifyEmailChangeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmailChange>>, TError,{data: BodyType<EmailChangeVerifyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyEmailChange>>, TError,{data: BodyType<EmailChangeVerifyInput>}, TContext> => {

const mutationKey = ['verifyEmailChange'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyEmailChange>>, {data: BodyType<EmailChangeVerifyInput>}> = (props) => {
          const {data} = props ?? {};

          return  verifyEmailChange(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyEmailChangeMutationResult = NonNullable<Awaited<ReturnType<typeof verifyEmailChange>>>
    export type VerifyEmailChangeMutationBody = BodyType<EmailChangeVerifyInput>
    export type VerifyEmailChangeMutationError = ErrorType<void>

    /**
 * @summary Confirm the code and update the sign-in and store contact emails
 */
export const useVerifyEmailChange = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmailChange>>, TError,{data: BodyType<EmailChangeVerifyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyEmailChange>>,
        TError,
        {data: BodyType<EmailChangeVerifyInput>},
        TContext
      > => {
      return useMutation(getVerifyEmailChangeMutationOptions(options));
    }

export const getUnsubscribeEmailUrl = () => {




  return `/api/auth/unsubscribe`
}

/**
 * @summary Confirm an optional email unsubscribe link
 */
export const unsubscribeEmail = async (emailUnsubscribeInput: EmailUnsubscribeInput, options?: RequestInit): Promise<EmailUnsubscribeResult> => {

  return customFetch<EmailUnsubscribeResult>(getUnsubscribeEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailUnsubscribeInput)
  }
);}




export const getUnsubscribeEmailMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribeEmail>>, TError,{data: BodyType<EmailUnsubscribeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unsubscribeEmail>>, TError,{data: BodyType<EmailUnsubscribeInput>}, TContext> => {

const mutationKey = ['unsubscribeEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unsubscribeEmail>>, {data: BodyType<EmailUnsubscribeInput>}> = (props) => {
          const {data} = props ?? {};

          return  unsubscribeEmail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnsubscribeEmailMutationResult = NonNullable<Awaited<ReturnType<typeof unsubscribeEmail>>>
    export type UnsubscribeEmailMutationBody = BodyType<EmailUnsubscribeInput>
    export type UnsubscribeEmailMutationError = ErrorType<void>

    /**
 * @summary Confirm an optional email unsubscribe link
 */
export const useUnsubscribeEmail = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribeEmail>>, TError,{data: BodyType<EmailUnsubscribeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unsubscribeEmail>>,
        TError,
        {data: BodyType<EmailUnsubscribeInput>},
        TContext
      > => {
      return useMutation(getUnsubscribeEmailMutationOptions(options));
    }

export const getListCategoriesUrl = () => {




  return `/api/categories`
}

/**
 * @summary List all categories
 */
export const listCategories = async ( options?: RequestInit): Promise<Category[]> => {

  return customFetch<Category[]>(getListCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCategoriesQueryKey = () => {
    return [
    `/api/categories`
    ] as const;
    }


export const getListCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listCategories>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCategories>>> = ({ signal }) => listCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCategories>>>
export type ListCategoriesQueryError = ErrorType<unknown>


/**
 * @summary List all categories
 */

export function useListCategories<TData = Awaited<ReturnType<typeof listCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCategories>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCategoriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCategoryUrl = () => {




  return `/api/categories`
}

/**
 * @summary Create a category
 */
export const createCategory = async (categoryInput: CategoryInput, options?: RequestInit): Promise<Category> => {

  return customFetch<Category>(getCreateCategoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(categoryInput)
  }
);}




export const getCreateCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{data: BodyType<CategoryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{data: BodyType<CategoryInput>}, TContext> => {

const mutationKey = ['createCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCategory>>, {data: BodyType<CategoryInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCategory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createCategory>>>
    export type CreateCategoryMutationBody = BodyType<CategoryInput>
    export type CreateCategoryMutationError = ErrorType<unknown>

    /**
 * @summary Create a category
 */
export const useCreateCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{data: BodyType<CategoryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCategory>>,
        TError,
        {data: BodyType<CategoryInput>},
        TContext
      > => {
      return useMutation(getCreateCategoryMutationOptions(options));
    }

export const getGetCategoryUrl = (id: number,) => {




  return `/api/categories/${id}`
}

/**
 * @summary Get a category
 */
export const getCategory = async (id: number, options?: RequestInit): Promise<Category> => {

  return customFetch<Category>(getGetCategoryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCategoryQueryKey = (id: number,) => {
    return [
    `/api/categories/${id}`
    ] as const;
    }


export const getGetCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getCategory>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategory>>> = ({ signal }) => getCategory(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getCategory>>>
export type GetCategoryQueryError = ErrorType<unknown>


/**
 * @summary Get a category
 */

export function useGetCategory<TData = Awaited<ReturnType<typeof getCategory>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCategoryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateCategoryUrl = (id: number,) => {




  return `/api/categories/${id}`
}

/**
 * @summary Update a category
 */
export const updateCategory = async (id: number,
    categoryUpdate: CategoryUpdate, options?: RequestInit): Promise<Category> => {

  return customFetch<Category>(getUpdateCategoryUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(categoryUpdate)
  }
);}




export const getUpdateCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: number;data: BodyType<CategoryUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: number;data: BodyType<CategoryUpdate>}, TContext> => {

const mutationKey = ['updateCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCategory>>, {id: number;data: BodyType<CategoryUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCategory(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateCategory>>>
    export type UpdateCategoryMutationBody = BodyType<CategoryUpdate>
    export type UpdateCategoryMutationError = ErrorType<unknown>

    /**
 * @summary Update a category
 */
export const useUpdateCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: number;data: BodyType<CategoryUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCategory>>,
        TError,
        {id: number;data: BodyType<CategoryUpdate>},
        TContext
      > => {
      return useMutation(getUpdateCategoryMutationOptions(options));
    }

export const getDeleteCategoryUrl = (id: number,) => {




  return `/api/categories/${id}`
}

/**
 * @summary Delete a category
 */
export const deleteCategory = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCategoryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCategoryMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCategory>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCategory(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCategory>>>

    export type DeleteCategoryMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Delete a category
 */
export const useDeleteCategory = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCategory>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCategoryMutationOptions(options));
    }

export const getListProductsUrl = (params?: ListProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/products?${stringifiedParams}` : `/api/products`
}

/**
 * @summary List products
 */
export const listProducts = async (params?: ListProductsParams, options?: RequestInit): Promise<Product[]> => {

  return customFetch<Product[]>(getListProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductsQueryKey = (params?: ListProductsParams,) => {
    return [
    `/api/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProductsQueryOptions = <TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>(params?: ListProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({ signal }) => listProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listProducts>>>
export type ListProductsQueryError = ErrorType<unknown>


/**
 * @summary List products
 */

export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>(
 params?: ListProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateProductUrl = () => {




  return `/api/products`
}

/**
 * @summary Create a product
 */
export const createProduct = async (productInput: ProductInput, options?: RequestInit): Promise<Product> => {

  return customFetch<Product>(getCreateProductUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(productInput)
  }
);}




export const getCreateProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<ProductInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<ProductInput>}, TContext> => {

const mutationKey = ['createProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProduct>>, {data: BodyType<ProductInput>}> = (props) => {
          const {data} = props ?? {};

          return  createProduct(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductMutationResult = NonNullable<Awaited<ReturnType<typeof createProduct>>>
    export type CreateProductMutationBody = BodyType<ProductInput>
    export type CreateProductMutationError = ErrorType<unknown>

    /**
 * @summary Create a product
 */
export const useCreateProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<ProductInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProduct>>,
        TError,
        {data: BodyType<ProductInput>},
        TContext
      > => {
      return useMutation(getCreateProductMutationOptions(options));
    }

export const getStartProductImportJobUrl = () => {




  return `/api/products/import-jobs`
}

/**
 * @summary Start a durable product import
 */
export const startProductImportJob = async (productImportJobInput: ProductImportJobInput, options?: RequestInit): Promise<ProductImportJob> => {

  return customFetch<ProductImportJob>(getStartProductImportJobUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(productImportJobInput)
  }
);}




export const getStartProductImportJobMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startProductImportJob>>, TError,{data: BodyType<ProductImportJobInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startProductImportJob>>, TError,{data: BodyType<ProductImportJobInput>}, TContext> => {

const mutationKey = ['startProductImportJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startProductImportJob>>, {data: BodyType<ProductImportJobInput>}> = (props) => {
          const {data} = props ?? {};

          return  startProductImportJob(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartProductImportJobMutationResult = NonNullable<Awaited<ReturnType<typeof startProductImportJob>>>
    export type StartProductImportJobMutationBody = BodyType<ProductImportJobInput>
    export type StartProductImportJobMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Start a durable product import
 */
export const useStartProductImportJob = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startProductImportJob>>, TError,{data: BodyType<ProductImportJobInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startProductImportJob>>,
        TError,
        {data: BodyType<ProductImportJobInput>},
        TContext
      > => {
      return useMutation(getStartProductImportJobMutationOptions(options));
    }

export const getPreviewProductImportBarcodesUrl = () => {




  return `/api/products/import-preview`
}

/**
 * @summary Validate product values and preview barcode conflicts before importing
 */
export const previewProductImportBarcodes = async (productImportBarcodePreviewInput: ProductImportBarcodePreviewInput, options?: RequestInit): Promise<ProductImportBarcodePreview> => {

  return customFetch<ProductImportBarcodePreview>(getPreviewProductImportBarcodesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(productImportBarcodePreviewInput)
  }
);}




export const getPreviewProductImportBarcodesMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewProductImportBarcodes>>, TError,{data: BodyType<ProductImportBarcodePreviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewProductImportBarcodes>>, TError,{data: BodyType<ProductImportBarcodePreviewInput>}, TContext> => {

const mutationKey = ['previewProductImportBarcodes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewProductImportBarcodes>>, {data: BodyType<ProductImportBarcodePreviewInput>}> = (props) => {
          const {data} = props ?? {};

          return  previewProductImportBarcodes(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewProductImportBarcodesMutationResult = NonNullable<Awaited<ReturnType<typeof previewProductImportBarcodes>>>
    export type PreviewProductImportBarcodesMutationBody = BodyType<ProductImportBarcodePreviewInput>
    export type PreviewProductImportBarcodesMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Validate product values and preview barcode conflicts before importing
 */
export const usePreviewProductImportBarcodes = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewProductImportBarcodes>>, TError,{data: BodyType<ProductImportBarcodePreviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof previewProductImportBarcodes>>,
        TError,
        {data: BodyType<ProductImportBarcodePreviewInput>},
        TContext
      > => {
      return useMutation(getPreviewProductImportBarcodesMutationOptions(options));
    }

export const getGetLatestProductImportJobUrl = () => {




  return `/api/products/import-jobs/latest`
}

/**
 * @summary Get the latest product import for the current store
 */
export const getLatestProductImportJob = async ( options?: RequestInit): Promise<GetLatestProductImportJob200> => {

  return customFetch<GetLatestProductImportJob200>(getGetLatestProductImportJobUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLatestProductImportJobQueryKey = () => {
    return [
    `/api/products/import-jobs/latest`
    ] as const;
    }


export const getGetLatestProductImportJobQueryOptions = <TData = Awaited<ReturnType<typeof getLatestProductImportJob>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLatestProductImportJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestProductImportJobQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestProductImportJob>>> = ({ signal }) => getLatestProductImportJob({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLatestProductImportJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLatestProductImportJobQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestProductImportJob>>>
export type GetLatestProductImportJobQueryError = ErrorType<unknown>


/**
 * @summary Get the latest product import for the current store
 */

export function useGetLatestProductImportJob<TData = Awaited<ReturnType<typeof getLatestProductImportJob>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLatestProductImportJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLatestProductImportJobQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetProductImportJobUrl = (id: number,) => {




  return `/api/products/import-jobs/${id}`
}

/**
 * @summary Get progress and results for a product import
 */
export const getProductImportJob = async (id: number, options?: RequestInit): Promise<ProductImportJob> => {

  return customFetch<ProductImportJob>(getGetProductImportJobUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductImportJobQueryKey = (id: number,) => {
    return [
    `/api/products/import-jobs/${id}`
    ] as const;
    }


export const getGetProductImportJobQueryOptions = <TData = Awaited<ReturnType<typeof getProductImportJob>>, TError = ErrorType<ErrorEnvelope>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductImportJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductImportJobQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductImportJob>>> = ({ signal }) => getProductImportJob(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductImportJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductImportJobQueryResult = NonNullable<Awaited<ReturnType<typeof getProductImportJob>>>
export type GetProductImportJobQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Get progress and results for a product import
 */

export function useGetProductImportJob<TData = Awaited<ReturnType<typeof getProductImportJob>>, TError = ErrorType<ErrorEnvelope>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductImportJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductImportJobQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetProductUrl = (id: number,) => {




  return `/api/products/${id}`
}

/**
 * @summary Get a product
 */
export const getProduct = async (id: number, options?: RequestInit): Promise<Product> => {

  return customFetch<Product>(getGetProductUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductQueryKey = (id: number,) => {
    return [
    `/api/products/${id}`
    ] as const;
    }


export const getGetProductQueryOptions = <TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({ signal }) => getProduct(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductQueryResult = NonNullable<Awaited<ReturnType<typeof getProduct>>>
export type GetProductQueryError = ErrorType<unknown>


/**
 * @summary Get a product
 */

export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateProductUrl = (id: number,) => {




  return `/api/products/${id}`
}

/**
 * @summary Update a product
 */
export const updateProduct = async (id: number,
    productUpdate: ProductUpdate, options?: RequestInit): Promise<Product> => {

  return customFetch<Product>(getUpdateProductUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(productUpdate)
  }
);}




export const getUpdateProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: BodyType<ProductUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: BodyType<ProductUpdate>}, TContext> => {

const mutationKey = ['updateProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProduct>>, {id: number;data: BodyType<ProductUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProduct(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductMutationResult = NonNullable<Awaited<ReturnType<typeof updateProduct>>>
    export type UpdateProductMutationBody = BodyType<ProductUpdate>
    export type UpdateProductMutationError = ErrorType<unknown>

    /**
 * @summary Update a product
 */
export const useUpdateProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: BodyType<ProductUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProduct>>,
        TError,
        {id: number;data: BodyType<ProductUpdate>},
        TContext
      > => {
      return useMutation(getUpdateProductMutationOptions(options));
    }

export const getDeleteProductUrl = (id: number,) => {




  return `/api/products/${id}`
}

/**
 * @summary Delete a product
 */
export const deleteProduct = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteProductUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProduct>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteProduct(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProduct>>>

    export type DeleteProductMutationError = ErrorType<unknown>

    /**
 * @summary Delete a product
 */
export const useDeleteProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProduct>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteProductMutationOptions(options));
    }

export const getListSuppliersUrl = () => {




  return `/api/suppliers`
}

/**
 * @summary List all suppliers
 */
export const listSuppliers = async ( options?: RequestInit): Promise<Supplier[]> => {

  return customFetch<Supplier[]>(getListSuppliersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSuppliersQueryKey = () => {
    return [
    `/api/suppliers`
    ] as const;
    }


export const getListSuppliersQueryOptions = <TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuppliersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuppliers>>> = ({ signal }) => listSuppliers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSuppliersQueryResult = NonNullable<Awaited<ReturnType<typeof listSuppliers>>>
export type ListSuppliersQueryError = ErrorType<unknown>


/**
 * @summary List all suppliers
 */

export function useListSuppliers<TData = Awaited<ReturnType<typeof listSuppliers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSuppliers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSuppliersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateSupplierUrl = () => {




  return `/api/suppliers`
}

/**
 * @summary Create a supplier
 */
export const createSupplier = async (supplierInput: SupplierInput, options?: RequestInit): Promise<Supplier> => {

  return customFetch<Supplier>(getCreateSupplierUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(supplierInput)
  }
);}




export const getCreateSupplierMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSupplier>>, TError,{data: BodyType<SupplierInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSupplier>>, TError,{data: BodyType<SupplierInput>}, TContext> => {

const mutationKey = ['createSupplier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSupplier>>, {data: BodyType<SupplierInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSupplier(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof createSupplier>>>
    export type CreateSupplierMutationBody = BodyType<SupplierInput>
    export type CreateSupplierMutationError = ErrorType<unknown>

    /**
 * @summary Create a supplier
 */
export const useCreateSupplier = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSupplier>>, TError,{data: BodyType<SupplierInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSupplier>>,
        TError,
        {data: BodyType<SupplierInput>},
        TContext
      > => {
      return useMutation(getCreateSupplierMutationOptions(options));
    }

export const getUpdateSupplierUrl = (id: number,) => {




  return `/api/suppliers/${id}`
}

/**
 * @summary Update a supplier
 */
export const updateSupplier = async (id: number,
    supplierUpdate: SupplierUpdate, options?: RequestInit): Promise<Supplier> => {

  return customFetch<Supplier>(getUpdateSupplierUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(supplierUpdate)
  }
);}




export const getUpdateSupplierMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSupplier>>, TError,{id: number;data: BodyType<SupplierUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSupplier>>, TError,{id: number;data: BodyType<SupplierUpdate>}, TContext> => {

const mutationKey = ['updateSupplier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSupplier>>, {id: number;data: BodyType<SupplierUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSupplier(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof updateSupplier>>>
    export type UpdateSupplierMutationBody = BodyType<SupplierUpdate>
    export type UpdateSupplierMutationError = ErrorType<unknown>

    /**
 * @summary Update a supplier
 */
export const useUpdateSupplier = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSupplier>>, TError,{id: number;data: BodyType<SupplierUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSupplier>>,
        TError,
        {id: number;data: BodyType<SupplierUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSupplierMutationOptions(options));
    }

export const getDeleteSupplierUrl = (id: number,) => {




  return `/api/suppliers/${id}`
}

/**
 * @summary Delete a supplier
 */
export const deleteSupplier = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteSupplierUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSupplierMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSupplier>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSupplier>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteSupplier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSupplier>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteSupplier(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSupplier>>>

    export type DeleteSupplierMutationError = ErrorType<unknown>

    /**
 * @summary Delete a supplier
 */
export const useDeleteSupplier = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSupplier>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSupplier>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteSupplierMutationOptions(options));
    }

export const getListSalesUrl = (params?: ListSalesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sales?${stringifiedParams}` : `/api/sales`
}

/**
 * @summary List sales transactions
 */
export const listSales = async (params?: ListSalesParams, options?: RequestInit): Promise<Sale[]> => {

  return customFetch<Sale[]>(getListSalesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSalesQueryKey = (params?: ListSalesParams,) => {
    return [
    `/api/sales`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSalesQueryOptions = <TData = Awaited<ReturnType<typeof listSales>>, TError = ErrorType<unknown>>(params?: ListSalesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSales>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSalesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSales>>> = ({ signal }) => listSales(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSales>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSalesQueryResult = NonNullable<Awaited<ReturnType<typeof listSales>>>
export type ListSalesQueryError = ErrorType<unknown>


/**
 * @summary List sales transactions
 */

export function useListSales<TData = Awaited<ReturnType<typeof listSales>>, TError = ErrorType<unknown>>(
 params?: ListSalesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSales>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSalesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateSaleUrl = () => {




  return `/api/sales`
}

/**
 * @summary Create a sale transaction
 */
export const createSale = async (saleInput: SaleInput, options?: RequestInit): Promise<Sale> => {

  return customFetch<Sale>(getCreateSaleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saleInput)
  }
);}




export const getCreateSaleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSale>>, TError,{data: BodyType<SaleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSale>>, TError,{data: BodyType<SaleInput>}, TContext> => {

const mutationKey = ['createSale'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSale>>, {data: BodyType<SaleInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSale(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSaleMutationResult = NonNullable<Awaited<ReturnType<typeof createSale>>>
    export type CreateSaleMutationBody = BodyType<SaleInput>
    export type CreateSaleMutationError = ErrorType<void>

    /**
 * @summary Create a sale transaction
 */
export const useCreateSale = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSale>>, TError,{data: BodyType<SaleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSale>>,
        TError,
        {data: BodyType<SaleInput>},
        TContext
      > => {
      return useMutation(getCreateSaleMutationOptions(options));
    }

export const getListSalesPageUrl = (params?: ListSalesPageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sales/page?${stringifiedParams}` : `/api/sales/page`
}

/**
 * @summary List a page of sales transactions
 */
export const listSalesPage = async (params?: ListSalesPageParams, options?: RequestInit): Promise<SalesPage> => {

  return customFetch<SalesPage>(getListSalesPageUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSalesPageQueryKey = (params?: ListSalesPageParams,) => {
    return [
    `/api/sales/page`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSalesPageQueryOptions = <TData = Awaited<ReturnType<typeof listSalesPage>>, TError = ErrorType<unknown>>(params?: ListSalesPageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalesPage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSalesPageQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSalesPage>>> = ({ signal }) => listSalesPage(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSalesPage>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSalesPageQueryResult = NonNullable<Awaited<ReturnType<typeof listSalesPage>>>
export type ListSalesPageQueryError = ErrorType<unknown>


/**
 * @summary List a page of sales transactions
 */

export function useListSalesPage<TData = Awaited<ReturnType<typeof listSalesPage>>, TError = ErrorType<unknown>>(
 params?: ListSalesPageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSalesPage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSalesPageQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListCustomerInvoicesUrl = (params?: ListCustomerInvoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customer-invoices?${stringifiedParams}` : `/api/customer-invoices`
}

/**
 * @summary List a cursor-paginated page of POS credit-sale invoices with receivables aging
 */
export const listCustomerInvoices = async (params?: ListCustomerInvoicesParams, options?: RequestInit): Promise<CustomerInvoicesResponse> => {

  return customFetch<CustomerInvoicesResponse>(getListCustomerInvoicesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerInvoicesQueryKey = (params?: ListCustomerInvoicesParams,) => {
    return [
    `/api/customer-invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomerInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerInvoices>>, TError = ErrorType<unknown>>(params?: ListCustomerInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerInvoicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerInvoices>>> = ({ signal }) => listCustomerInvoices(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerInvoices>>>
export type ListCustomerInvoicesQueryError = ErrorType<unknown>


/**
 * @summary List a cursor-paginated page of POS credit-sale invoices with receivables aging
 */

export function useListCustomerInvoices<TData = Awaited<ReturnType<typeof listCustomerInvoices>>, TError = ErrorType<unknown>>(
 params?: ListCustomerInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getExportCustomerInvoicesUrl = (params?: ExportCustomerInvoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customer-invoices/export?${stringifiedParams}` : `/api/customer-invoices/export`
}

/**
 * @summary Download matching POS credit-sale invoices as a CSV aging report
 */
export const exportCustomerInvoices = async (params?: ExportCustomerInvoicesParams, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getExportCustomerInvoicesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportCustomerInvoicesQueryKey = (params?: ExportCustomerInvoicesParams,) => {
    return [
    `/api/customer-invoices/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportCustomerInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof exportCustomerInvoices>>, TError = ErrorType<unknown>>(params?: ExportCustomerInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportCustomerInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportCustomerInvoicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportCustomerInvoices>>> = ({ signal }) => exportCustomerInvoices(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportCustomerInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportCustomerInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof exportCustomerInvoices>>>
export type ExportCustomerInvoicesQueryError = ErrorType<unknown>


/**
 * @summary Download matching POS credit-sale invoices as a CSV aging report
 */

export function useExportCustomerInvoices<TData = Awaited<ReturnType<typeof exportCustomerInvoices>>, TError = ErrorType<unknown>>(
 params?: ExportCustomerInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportCustomerInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportCustomerInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetCustomerInvoiceUrl = (id: number,) => {




  return `/api/customer-invoices/${id}`
}

/**
 * @summary Get a POS credit invoice with its items, payments, and reminders
 */
export const getCustomerInvoice = async (id: number, options?: RequestInit): Promise<CustomerInvoiceDetail> => {

  return customFetch<CustomerInvoiceDetail>(getGetCustomerInvoiceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerInvoiceQueryKey = (id: number,) => {
    return [
    `/api/customer-invoices/${id}`
    ] as const;
    }


export const getGetCustomerInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerInvoice>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerInvoice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerInvoiceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerInvoice>>> = ({ signal }) => getCustomerInvoice(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerInvoice>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerInvoice>>>
export type GetCustomerInvoiceQueryError = ErrorType<void>


/**
 * @summary Get a POS credit invoice with its items, payments, and reminders
 */

export function useGetCustomerInvoice<TData = Awaited<ReturnType<typeof getCustomerInvoice>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomerInvoice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerInvoiceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateCustomerInvoiceUrl = (id: number,) => {




  return `/api/customer-invoices/${id}`
}

/**
 * @summary Update the due date of an existing POS credit invoice
 */
export const updateCustomerInvoice = async (id: number,
    customerInvoiceUpdate: CustomerInvoiceUpdate, options?: RequestInit): Promise<CustomerInvoice> => {

  return customFetch<CustomerInvoice>(getUpdateCustomerInvoiceUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerInvoiceUpdate)
  }
);}




export const getUpdateCustomerInvoiceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomerInvoice>>, TError,{id: number;data: BodyType<CustomerInvoiceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomerInvoice>>, TError,{id: number;data: BodyType<CustomerInvoiceUpdate>}, TContext> => {

const mutationKey = ['updateCustomerInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomerInvoice>>, {id: number;data: BodyType<CustomerInvoiceUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCustomerInvoice(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomerInvoice>>>
    export type UpdateCustomerInvoiceMutationBody = BodyType<CustomerInvoiceUpdate>
    export type UpdateCustomerInvoiceMutationError = ErrorType<void>

    /**
 * @summary Update the due date of an existing POS credit invoice
 */
export const useUpdateCustomerInvoice = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomerInvoice>>, TError,{id: number;data: BodyType<CustomerInvoiceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomerInvoice>>,
        TError,
        {id: number;data: BodyType<CustomerInvoiceUpdate>},
        TContext
      > => {
      return useMutation(getUpdateCustomerInvoiceMutationOptions(options));
    }

export const getListCustomerInvoiceRemindersUrl = (id: number,) => {




  return `/api/customer-invoices/${id}/reminders`
}

/**
 * @summary List manually initiated reminders for an invoice
 */
export const listCustomerInvoiceReminders = async (id: number, options?: RequestInit): Promise<CustomerInvoiceReminder[]> => {

  return customFetch<CustomerInvoiceReminder[]>(getListCustomerInvoiceRemindersUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomerInvoiceRemindersQueryKey = (id: number,) => {
    return [
    `/api/customer-invoices/${id}/reminders`
    ] as const;
    }


export const getListCustomerInvoiceRemindersQueryOptions = <TData = Awaited<ReturnType<typeof listCustomerInvoiceReminders>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerInvoiceReminders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerInvoiceRemindersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerInvoiceReminders>>> = ({ signal }) => listCustomerInvoiceReminders(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomerInvoiceReminders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerInvoiceRemindersQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomerInvoiceReminders>>>
export type ListCustomerInvoiceRemindersQueryError = ErrorType<void>


/**
 * @summary List manually initiated reminders for an invoice
 */

export function useListCustomerInvoiceReminders<TData = Awaited<ReturnType<typeof listCustomerInvoiceReminders>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomerInvoiceReminders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomerInvoiceRemindersQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSendCustomerInvoiceReminderUrl = (id: number,) => {




  return `/api/customer-invoices/${id}/reminders`
}

/**
 * @summary Manually send one invoice-specific payment reminder
 */
export const sendCustomerInvoiceReminder = async (id: number,
    customerInvoiceReminderRequest: CustomerInvoiceReminderRequest, options?: RequestInit): Promise<CustomerInvoiceReminder> => {

  return customFetch<CustomerInvoiceReminder>(getSendCustomerInvoiceReminderUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerInvoiceReminderRequest)
  }
);}




export const getSendCustomerInvoiceReminderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCustomerInvoiceReminder>>, TError,{id: number;data: BodyType<CustomerInvoiceReminderRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendCustomerInvoiceReminder>>, TError,{id: number;data: BodyType<CustomerInvoiceReminderRequest>}, TContext> => {

const mutationKey = ['sendCustomerInvoiceReminder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCustomerInvoiceReminder>>, {id: number;data: BodyType<CustomerInvoiceReminderRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendCustomerInvoiceReminder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendCustomerInvoiceReminderMutationResult = NonNullable<Awaited<ReturnType<typeof sendCustomerInvoiceReminder>>>
    export type SendCustomerInvoiceReminderMutationBody = BodyType<CustomerInvoiceReminderRequest>
    export type SendCustomerInvoiceReminderMutationError = ErrorType<void>

    /**
 * @summary Manually send one invoice-specific payment reminder
 */
export const useSendCustomerInvoiceReminder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCustomerInvoiceReminder>>, TError,{id: number;data: BodyType<CustomerInvoiceReminderRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendCustomerInvoiceReminder>>,
        TError,
        {id: number;data: BodyType<CustomerInvoiceReminderRequest>},
        TContext
      > => {
      return useMutation(getSendCustomerInvoiceReminderMutationOptions(options));
    }

export const getRecordSalePaymentUrl = (id: number,) => {




  return `/api/sales/${id}/payment`
}

/**
 * @summary Record a payment against the matching POS credit sale
 */
export const recordSalePayment = async (id: number,
    recordSalePaymentInput: RecordSalePaymentInput, options?: RequestInit): Promise<RecordSalePaymentResult> => {

  return customFetch<RecordSalePaymentResult>(getRecordSalePaymentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recordSalePaymentInput)
  }
);}




export const getRecordSalePaymentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordSalePayment>>, TError,{id: number;data: BodyType<RecordSalePaymentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordSalePayment>>, TError,{id: number;data: BodyType<RecordSalePaymentInput>}, TContext> => {

const mutationKey = ['recordSalePayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordSalePayment>>, {id: number;data: BodyType<RecordSalePaymentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  recordSalePayment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordSalePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordSalePayment>>>
    export type RecordSalePaymentMutationBody = BodyType<RecordSalePaymentInput>
    export type RecordSalePaymentMutationError = ErrorType<void>

    /**
 * @summary Record a payment against the matching POS credit sale
 */
export const useRecordSalePayment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordSalePayment>>, TError,{id: number;data: BodyType<RecordSalePaymentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordSalePayment>>,
        TError,
        {id: number;data: BodyType<RecordSalePaymentInput>},
        TContext
      > => {
      return useMutation(getRecordSalePaymentMutationOptions(options));
    }

export const getEmailSaleReceiptUrl = (id: number,) => {




  return `/api/sales/${id}/email`
}

/**
 * @summary Send or resend a POS receipt (SMTP acceptance is not inbox delivery)
 */
export const emailSaleReceipt = async (id: number,
    receiptEmailRequest?: ReceiptEmailRequest, options?: RequestInit): Promise<ReceiptEmailStatus> => {

  return customFetch<ReceiptEmailStatus>(getEmailSaleReceiptUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(receiptEmailRequest)
  }
);}




export const getEmailSaleReceiptMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailSaleReceipt>>, TError,{id: number;data?: BodyType<ReceiptEmailRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof emailSaleReceipt>>, TError,{id: number;data?: BodyType<ReceiptEmailRequest>}, TContext> => {

const mutationKey = ['emailSaleReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emailSaleReceipt>>, {id: number;data?: BodyType<ReceiptEmailRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  emailSaleReceipt(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmailSaleReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof emailSaleReceipt>>>
    export type EmailSaleReceiptMutationBody = BodyType<ReceiptEmailRequest> | undefined
    export type EmailSaleReceiptMutationError = ErrorType<unknown>

    /**
 * @summary Send or resend a POS receipt (SMTP acceptance is not inbox delivery)
 */
export const useEmailSaleReceipt = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailSaleReceipt>>, TError,{id: number;data?: BodyType<ReceiptEmailRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof emailSaleReceipt>>,
        TError,
        {id: number;data?: BodyType<ReceiptEmailRequest>},
        TContext
      > => {
      return useMutation(getEmailSaleReceiptMutationOptions(options));
    }

export const getGetSaleUrl = (id: number,) => {




  return `/api/sales/${id}`
}

/**
 * @summary Get a sale with line items
 */
export const getSale = async (id: number, options?: RequestInit): Promise<SaleDetail> => {

  return customFetch<SaleDetail>(getGetSaleUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSaleQueryKey = (id: number,) => {
    return [
    `/api/sales/${id}`
    ] as const;
    }


export const getGetSaleQueryOptions = <TData = Awaited<ReturnType<typeof getSale>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSale>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSaleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSale>>> = ({ signal }) => getSale(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSale>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSaleQueryResult = NonNullable<Awaited<ReturnType<typeof getSale>>>
export type GetSaleQueryError = ErrorType<unknown>


/**
 * @summary Get a sale with line items
 */

export function useGetSale<TData = Awaited<ReturnType<typeof getSale>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSale>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSaleQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateSaleUrl = (id: number,) => {




  return `/api/sales/${id}`
}

/**
 * @summary Edit sale metadata (admin only)
 */
export const updateSale = async (id: number,
    updateSaleInput: UpdateSaleInput, options?: RequestInit): Promise<SaleDetail> => {

  return customFetch<SaleDetail>(getUpdateSaleUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSaleInput)
  }
);}




export const getUpdateSaleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSale>>, TError,{id: number;data: BodyType<UpdateSaleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSale>>, TError,{id: number;data: BodyType<UpdateSaleInput>}, TContext> => {

const mutationKey = ['updateSale'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSale>>, {id: number;data: BodyType<UpdateSaleInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSale(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSaleMutationResult = NonNullable<Awaited<ReturnType<typeof updateSale>>>
    export type UpdateSaleMutationBody = BodyType<UpdateSaleInput>
    export type UpdateSaleMutationError = ErrorType<unknown>

    /**
 * @summary Edit sale metadata (admin only)
 */
export const useUpdateSale = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSale>>, TError,{id: number;data: BodyType<UpdateSaleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSale>>,
        TError,
        {id: number;data: BodyType<UpdateSaleInput>},
        TContext
      > => {
      return useMutation(getUpdateSaleMutationOptions(options));
    }

export const getDeleteSaleUrl = (id: number,) => {




  return `/api/sales/${id}`
}

/**
 * @summary Delete a sale and restore stock (admin only)
 */
export const deleteSale = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteSaleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSaleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSale>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSale>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteSale'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSale>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteSale(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSaleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSale>>>

    export type DeleteSaleMutationError = ErrorType<unknown>

    /**
 * @summary Delete a sale and restore stock (admin only)
 */
export const useDeleteSale = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSale>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSale>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteSaleMutationOptions(options));
    }

export const getListPurchasesUrl = (params?: ListPurchasesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/purchases?${stringifiedParams}` : `/api/purchases`
}

/**
 * @summary List purchase orders
 */
export const listPurchases = async (params?: ListPurchasesParams, options?: RequestInit): Promise<Purchase[]> => {

  return customFetch<Purchase[]>(getListPurchasesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPurchasesQueryKey = (params?: ListPurchasesParams,) => {
    return [
    `/api/purchases`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPurchasesQueryOptions = <TData = Awaited<ReturnType<typeof listPurchases>>, TError = ErrorType<unknown>>(params?: ListPurchasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchases>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPurchasesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPurchases>>> = ({ signal }) => listPurchases(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPurchases>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPurchasesQueryResult = NonNullable<Awaited<ReturnType<typeof listPurchases>>>
export type ListPurchasesQueryError = ErrorType<unknown>


/**
 * @summary List purchase orders
 */

export function useListPurchases<TData = Awaited<ReturnType<typeof listPurchases>>, TError = ErrorType<unknown>>(
 params?: ListPurchasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPurchases>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPurchasesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePurchaseUrl = () => {




  return `/api/purchases`
}

/**
 * @summary Create a purchase order
 */
export const createPurchase = async (purchaseInput: PurchaseInput, options?: RequestInit): Promise<Purchase> => {

  return customFetch<Purchase>(getCreatePurchaseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseInput)
  }
);}




export const getCreatePurchaseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPurchase>>, TError,{data: BodyType<PurchaseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPurchase>>, TError,{data: BodyType<PurchaseInput>}, TContext> => {

const mutationKey = ['createPurchase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPurchase>>, {data: BodyType<PurchaseInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPurchase(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePurchaseMutationResult = NonNullable<Awaited<ReturnType<typeof createPurchase>>>
    export type CreatePurchaseMutationBody = BodyType<PurchaseInput>
    export type CreatePurchaseMutationError = ErrorType<unknown>

    /**
 * @summary Create a purchase order
 */
export const useCreatePurchase = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPurchase>>, TError,{data: BodyType<PurchaseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPurchase>>,
        TError,
        {data: BodyType<PurchaseInput>},
        TContext
      > => {
      return useMutation(getCreatePurchaseMutationOptions(options));
    }

export const getGetPurchaseUrl = (id: number,) => {




  return `/api/purchases/${id}`
}

/**
 * @summary Get a purchase order with items
 */
export const getPurchase = async (id: number, options?: RequestInit): Promise<PurchaseDetail> => {

  return customFetch<PurchaseDetail>(getGetPurchaseUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPurchaseQueryKey = (id: number,) => {
    return [
    `/api/purchases/${id}`
    ] as const;
    }


export const getGetPurchaseQueryOptions = <TData = Awaited<ReturnType<typeof getPurchase>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchase>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPurchaseQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchase>>> = ({ signal }) => getPurchase(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPurchase>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPurchaseQueryResult = NonNullable<Awaited<ReturnType<typeof getPurchase>>>
export type GetPurchaseQueryError = ErrorType<unknown>


/**
 * @summary Get a purchase order with items
 */

export function useGetPurchase<TData = Awaited<ReturnType<typeof getPurchase>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPurchase>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPurchaseQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdatePurchaseUrl = (id: number,) => {




  return `/api/purchases/${id}`
}

/**
 * @summary Update purchase (e.g. mark received)
 */
export const updatePurchase = async (id: number,
    purchaseUpdate: PurchaseUpdate, options?: RequestInit): Promise<Purchase> => {

  return customFetch<Purchase>(getUpdatePurchaseUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(purchaseUpdate)
  }
);}




export const getUpdatePurchaseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchase>>, TError,{id: number;data: BodyType<PurchaseUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePurchase>>, TError,{id: number;data: BodyType<PurchaseUpdate>}, TContext> => {

const mutationKey = ['updatePurchase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePurchase>>, {id: number;data: BodyType<PurchaseUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePurchase(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePurchaseMutationResult = NonNullable<Awaited<ReturnType<typeof updatePurchase>>>
    export type UpdatePurchaseMutationBody = BodyType<PurchaseUpdate>
    export type UpdatePurchaseMutationError = ErrorType<unknown>

    /**
 * @summary Update purchase (e.g. mark received)
 */
export const useUpdatePurchase = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePurchase>>, TError,{id: number;data: BodyType<PurchaseUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePurchase>>,
        TError,
        {id: number;data: BodyType<PurchaseUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePurchaseMutationOptions(options));
    }

export const getListSupplierBillsUrl = () => {




  return `/api/supplier-bills`
}

/**
 * @summary List supplier bills and amounts due
 */
export const listSupplierBills = async ( options?: RequestInit): Promise<SupplierBillList> => {

  return customFetch<SupplierBillList>(getListSupplierBillsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSupplierBillsQueryKey = () => {
    return [
    `/api/supplier-bills`
    ] as const;
    }


export const getListSupplierBillsQueryOptions = <TData = Awaited<ReturnType<typeof listSupplierBills>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierBills>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSupplierBillsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSupplierBills>>> = ({ signal }) => listSupplierBills({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSupplierBills>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSupplierBillsQueryResult = NonNullable<Awaited<ReturnType<typeof listSupplierBills>>>
export type ListSupplierBillsQueryError = ErrorType<unknown>


/**
 * @summary List supplier bills and amounts due
 */

export function useListSupplierBills<TData = Awaited<ReturnType<typeof listSupplierBills>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSupplierBills>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSupplierBillsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateSupplierBillUrl = () => {




  return `/api/supplier-bills`
}

/**
 * @summary Record a supplier bill
 */
export const createSupplierBill = async (supplierBillInput: SupplierBillInput, options?: RequestInit): Promise<SupplierBill> => {

  return customFetch<SupplierBill>(getCreateSupplierBillUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(supplierBillInput)
  }
);}




export const getCreateSupplierBillMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSupplierBill>>, TError,{data: BodyType<SupplierBillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSupplierBill>>, TError,{data: BodyType<SupplierBillInput>}, TContext> => {

const mutationKey = ['createSupplierBill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSupplierBill>>, {data: BodyType<SupplierBillInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSupplierBill(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSupplierBillMutationResult = NonNullable<Awaited<ReturnType<typeof createSupplierBill>>>
    export type CreateSupplierBillMutationBody = BodyType<SupplierBillInput>
    export type CreateSupplierBillMutationError = ErrorType<unknown>

    /**
 * @summary Record a supplier bill
 */
export const useCreateSupplierBill = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSupplierBill>>, TError,{data: BodyType<SupplierBillInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSupplierBill>>,
        TError,
        {data: BodyType<SupplierBillInput>},
        TContext
      > => {
      return useMutation(getCreateSupplierBillMutationOptions(options));
    }

export const getGetSupplierBillUrl = (id: number,) => {




  return `/api/supplier-bills/${id}`
}

/**
 * @summary Get a supplier bill and its payment history
 */
export const getSupplierBill = async (id: number, options?: RequestInit): Promise<SupplierBillDetail> => {

  return customFetch<SupplierBillDetail>(getGetSupplierBillUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSupplierBillQueryKey = (id: number,) => {
    return [
    `/api/supplier-bills/${id}`
    ] as const;
    }


export const getGetSupplierBillQueryOptions = <TData = Awaited<ReturnType<typeof getSupplierBill>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierBill>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierBillQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplierBill>>> = ({ signal }) => getSupplierBill(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupplierBill>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupplierBillQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplierBill>>>
export type GetSupplierBillQueryError = ErrorType<void>


/**
 * @summary Get a supplier bill and its payment history
 */

export function useGetSupplierBill<TData = Awaited<ReturnType<typeof getSupplierBill>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierBill>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupplierBillQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRecordSupplierBillPaymentUrl = (id: number,) => {




  return `/api/supplier-bills/${id}/payments`
}

/**
 * @summary Record a payment against a supplier bill
 */
export const recordSupplierBillPayment = async (id: number,
    supplierBillPaymentInput: SupplierBillPaymentInput, options?: RequestInit): Promise<SupplierBillDetail> => {

  return customFetch<SupplierBillDetail>(getRecordSupplierBillPaymentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(supplierBillPaymentInput)
  }
);}




export const getRecordSupplierBillPaymentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordSupplierBillPayment>>, TError,{id: number;data: BodyType<SupplierBillPaymentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordSupplierBillPayment>>, TError,{id: number;data: BodyType<SupplierBillPaymentInput>}, TContext> => {

const mutationKey = ['recordSupplierBillPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordSupplierBillPayment>>, {id: number;data: BodyType<SupplierBillPaymentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  recordSupplierBillPayment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordSupplierBillPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordSupplierBillPayment>>>
    export type RecordSupplierBillPaymentMutationBody = BodyType<SupplierBillPaymentInput>
    export type RecordSupplierBillPaymentMutationError = ErrorType<unknown>

    /**
 * @summary Record a payment against a supplier bill
 */
export const useRecordSupplierBillPayment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordSupplierBillPayment>>, TError,{id: number;data: BodyType<SupplierBillPaymentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordSupplierBillPayment>>,
        TError,
        {id: number;data: BodyType<SupplierBillPaymentInput>},
        TContext
      > => {
      return useMutation(getRecordSupplierBillPaymentMutationOptions(options));
    }

export const getRequestSupplierBillReceiptUploadUrlUrl = (id: number,) => {




  return `/api/supplier-bills/${id}/receipt/upload-url`
}

/**
 * @summary Request a store-scoped upload URL for a bill receipt
 */
export const requestSupplierBillReceiptUploadUrl = async (id: number,
    uploadUrlRequest: UploadUrlRequest, options?: RequestInit): Promise<UploadUrlResponse> => {

  return customFetch<UploadUrlResponse>(getRequestSupplierBillReceiptUploadUrlUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadUrlRequest)
  }
);}




export const getRequestSupplierBillReceiptUploadUrlMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestSupplierBillReceiptUploadUrl>>, TError,{id: number;data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestSupplierBillReceiptUploadUrl>>, TError,{id: number;data: BodyType<UploadUrlRequest>}, TContext> => {

const mutationKey = ['requestSupplierBillReceiptUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestSupplierBillReceiptUploadUrl>>, {id: number;data: BodyType<UploadUrlRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  requestSupplierBillReceiptUploadUrl(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestSupplierBillReceiptUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestSupplierBillReceiptUploadUrl>>>
    export type RequestSupplierBillReceiptUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestSupplierBillReceiptUploadUrlMutationError = ErrorType<unknown>

    /**
 * @summary Request a store-scoped upload URL for a bill receipt
 */
export const useRequestSupplierBillReceiptUploadUrl = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestSupplierBillReceiptUploadUrl>>, TError,{id: number;data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestSupplierBillReceiptUploadUrl>>,
        TError,
        {id: number;data: BodyType<UploadUrlRequest>},
        TContext
      > => {
      return useMutation(getRequestSupplierBillReceiptUploadUrlMutationOptions(options));
    }

export const getAttachSupplierBillReceiptUrl = (id: number,) => {




  return `/api/supplier-bills/${id}/receipt`
}

/**
 * @summary Attach an uploaded receipt to a supplier bill
 */
export const attachSupplierBillReceipt = async (id: number,
    supplierBillReceiptInput: SupplierBillReceiptInput, options?: RequestInit): Promise<SupplierBill> => {

  return customFetch<SupplierBill>(getAttachSupplierBillReceiptUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(supplierBillReceiptInput)
  }
);}




export const getAttachSupplierBillReceiptMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachSupplierBillReceipt>>, TError,{id: number;data: BodyType<SupplierBillReceiptInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof attachSupplierBillReceipt>>, TError,{id: number;data: BodyType<SupplierBillReceiptInput>}, TContext> => {

const mutationKey = ['attachSupplierBillReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attachSupplierBillReceipt>>, {id: number;data: BodyType<SupplierBillReceiptInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  attachSupplierBillReceipt(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AttachSupplierBillReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof attachSupplierBillReceipt>>>
    export type AttachSupplierBillReceiptMutationBody = BodyType<SupplierBillReceiptInput>
    export type AttachSupplierBillReceiptMutationError = ErrorType<unknown>

    /**
 * @summary Attach an uploaded receipt to a supplier bill
 */
export const useAttachSupplierBillReceipt = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachSupplierBillReceipt>>, TError,{id: number;data: BodyType<SupplierBillReceiptInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof attachSupplierBillReceipt>>,
        TError,
        {id: number;data: BodyType<SupplierBillReceiptInput>},
        TContext
      > => {
      return useMutation(getAttachSupplierBillReceiptMutationOptions(options));
    }

export const getGetSupplierBillReceiptUrl = (id: number,) => {




  return `/api/supplier-bills/${id}/receipt`
}

/**
 * @summary Stream the receipt for a supplier bill
 */
export const getSupplierBillReceipt = async (id: number, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetSupplierBillReceiptUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSupplierBillReceiptQueryKey = (id: number,) => {
    return [
    `/api/supplier-bills/${id}/receipt`
    ] as const;
    }


export const getGetSupplierBillReceiptQueryOptions = <TData = Awaited<ReturnType<typeof getSupplierBillReceipt>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierBillReceipt>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierBillReceiptQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplierBillReceipt>>> = ({ signal }) => getSupplierBillReceipt(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupplierBillReceipt>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupplierBillReceiptQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplierBillReceipt>>>
export type GetSupplierBillReceiptQueryError = ErrorType<unknown>


/**
 * @summary Stream the receipt for a supplier bill
 */

export function useGetSupplierBillReceipt<TData = Awaited<ReturnType<typeof getSupplierBillReceipt>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierBillReceipt>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupplierBillReceiptQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListStaffUrl = (params?: ListStaffParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staff?${stringifiedParams}` : `/api/staff`
}

/**
 * @summary List all staff
 */
export const listStaff = async (params?: ListStaffParams, options?: RequestInit): Promise<StaffMember[]> => {

  return customFetch<StaffMember[]>(getListStaffUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStaffQueryKey = (params?: ListStaffParams,) => {
    return [
    `/api/staff`, ...(params ? [params] : [])
    ] as const;
    }


export const getListStaffQueryOptions = <TData = Awaited<ReturnType<typeof listStaff>>, TError = ErrorType<unknown>>(params?: ListStaffParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStaffQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStaff>>> = ({ signal }) => listStaff(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStaff>>, TError, TData> & { queryKey: QueryKey }
}

export type ListStaffQueryResult = NonNullable<Awaited<ReturnType<typeof listStaff>>>
export type ListStaffQueryError = ErrorType<unknown>


/**
 * @summary List all staff
 */

export function useListStaff<TData = Awaited<ReturnType<typeof listStaff>>, TError = ErrorType<unknown>>(
 params?: ListStaffParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListStaffQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateStaffUrl = () => {




  return `/api/staff`
}

/**
 * @summary Create a staff member
 */
export const createStaff = async (staffInput: StaffInput, options?: RequestInit): Promise<StaffMember> => {

  return customFetch<StaffMember>(getCreateStaffUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(staffInput)
  }
);}




export const getCreateStaffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStaff>>, TError,{data: BodyType<StaffInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createStaff>>, TError,{data: BodyType<StaffInput>}, TContext> => {

const mutationKey = ['createStaff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStaff>>, {data: BodyType<StaffInput>}> = (props) => {
          const {data} = props ?? {};

          return  createStaff(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStaffMutationResult = NonNullable<Awaited<ReturnType<typeof createStaff>>>
    export type CreateStaffMutationBody = BodyType<StaffInput>
    export type CreateStaffMutationError = ErrorType<unknown>

    /**
 * @summary Create a staff member
 */
export const useCreateStaff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStaff>>, TError,{data: BodyType<StaffInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createStaff>>,
        TError,
        {data: BodyType<StaffInput>},
        TContext
      > => {
      return useMutation(getCreateStaffMutationOptions(options));
    }

export const getGetStaffUrl = (id: number,) => {




  return `/api/staff/${id}`
}

/**
 * @summary Get a staff member
 */
export const getStaff = async (id: number, options?: RequestInit): Promise<StaffMember> => {

  return customFetch<StaffMember>(getGetStaffUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStaffQueryKey = (id: number,) => {
    return [
    `/api/staff/${id}`
    ] as const;
    }


export const getGetStaffQueryOptions = <TData = Awaited<ReturnType<typeof getStaff>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStaffQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStaff>>> = ({ signal }) => getStaff(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStaff>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStaffQueryResult = NonNullable<Awaited<ReturnType<typeof getStaff>>>
export type GetStaffQueryError = ErrorType<unknown>


/**
 * @summary Get a staff member
 */

export function useGetStaff<TData = Awaited<ReturnType<typeof getStaff>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStaff>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStaffQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateStaffUrl = (id: number,) => {




  return `/api/staff/${id}`
}

/**
 * @summary Update a staff member
 */
export const updateStaff = async (id: number,
    staffUpdate: StaffUpdate, options?: RequestInit): Promise<StaffMember> => {

  return customFetch<StaffMember>(getUpdateStaffUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(staffUpdate)
  }
);}




export const getUpdateStaffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStaff>>, TError,{id: number;data: BodyType<StaffUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStaff>>, TError,{id: number;data: BodyType<StaffUpdate>}, TContext> => {

const mutationKey = ['updateStaff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStaff>>, {id: number;data: BodyType<StaffUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateStaff(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStaffMutationResult = NonNullable<Awaited<ReturnType<typeof updateStaff>>>
    export type UpdateStaffMutationBody = BodyType<StaffUpdate>
    export type UpdateStaffMutationError = ErrorType<unknown>

    /**
 * @summary Update a staff member
 */
export const useUpdateStaff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStaff>>, TError,{id: number;data: BodyType<StaffUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateStaff>>,
        TError,
        {id: number;data: BodyType<StaffUpdate>},
        TContext
      > => {
      return useMutation(getUpdateStaffMutationOptions(options));
    }

export const getDeleteStaffUrl = (id: number,) => {




  return `/api/staff/${id}`
}

/**
 * @summary Delete a staff member
 */
export const deleteStaff = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteStaffUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteStaffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStaff>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStaff>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteStaff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStaff>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteStaff(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStaffMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStaff>>>

    export type DeleteStaffMutationError = ErrorType<unknown>

    /**
 * @summary Delete a staff member
 */
export const useDeleteStaff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStaff>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteStaff>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteStaffMutationOptions(options));
    }

export const getListExpensesUrl = (params?: ListExpensesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/expenses?${stringifiedParams}` : `/api/expenses`
}

/**
 * @summary List expenses
 */
export const listExpenses = async (params?: ListExpensesParams, options?: RequestInit): Promise<Expense[]> => {

  return customFetch<Expense[]>(getListExpensesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExpensesQueryKey = (params?: ListExpensesParams,) => {
    return [
    `/api/expenses`, ...(params ? [params] : [])
    ] as const;
    }


export const getListExpensesQueryOptions = <TData = Awaited<ReturnType<typeof listExpenses>>, TError = ErrorType<unknown>>(params?: ListExpensesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExpenses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExpensesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExpenses>>> = ({ signal }) => listExpenses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExpenses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListExpensesQueryResult = NonNullable<Awaited<ReturnType<typeof listExpenses>>>
export type ListExpensesQueryError = ErrorType<unknown>


/**
 * @summary List expenses
 */

export function useListExpenses<TData = Awaited<ReturnType<typeof listExpenses>>, TError = ErrorType<unknown>>(
 params?: ListExpensesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExpenses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListExpensesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateExpenseUrl = () => {




  return `/api/expenses`
}

/**
 * @summary Record an expense
 */
export const createExpense = async (expenseInput: ExpenseInput, options?: RequestInit): Promise<Expense> => {

  return customFetch<Expense>(getCreateExpenseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(expenseInput)
  }
);}




export const getCreateExpenseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExpense>>, TError,{data: BodyType<ExpenseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createExpense>>, TError,{data: BodyType<ExpenseInput>}, TContext> => {

const mutationKey = ['createExpense'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExpense>>, {data: BodyType<ExpenseInput>}> = (props) => {
          const {data} = props ?? {};

          return  createExpense(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExpenseMutationResult = NonNullable<Awaited<ReturnType<typeof createExpense>>>
    export type CreateExpenseMutationBody = BodyType<ExpenseInput>
    export type CreateExpenseMutationError = ErrorType<unknown>

    /**
 * @summary Record an expense
 */
export const useCreateExpense = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExpense>>, TError,{data: BodyType<ExpenseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createExpense>>,
        TError,
        {data: BodyType<ExpenseInput>},
        TContext
      > => {
      return useMutation(getCreateExpenseMutationOptions(options));
    }

export const getUpdateExpenseUrl = (id: number,) => {




  return `/api/expenses/${id}`
}

/**
 * @summary Update an expense
 */
export const updateExpense = async (id: number,
    expenseUpdate: ExpenseUpdate, options?: RequestInit): Promise<Expense> => {

  return customFetch<Expense>(getUpdateExpenseUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(expenseUpdate)
  }
);}




export const getUpdateExpenseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateExpense>>, TError,{id: number;data: BodyType<ExpenseUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateExpense>>, TError,{id: number;data: BodyType<ExpenseUpdate>}, TContext> => {

const mutationKey = ['updateExpense'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateExpense>>, {id: number;data: BodyType<ExpenseUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateExpense(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateExpenseMutationResult = NonNullable<Awaited<ReturnType<typeof updateExpense>>>
    export type UpdateExpenseMutationBody = BodyType<ExpenseUpdate>
    export type UpdateExpenseMutationError = ErrorType<unknown>

    /**
 * @summary Update an expense
 */
export const useUpdateExpense = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateExpense>>, TError,{id: number;data: BodyType<ExpenseUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateExpense>>,
        TError,
        {id: number;data: BodyType<ExpenseUpdate>},
        TContext
      > => {
      return useMutation(getUpdateExpenseMutationOptions(options));
    }

export const getDeleteExpenseUrl = (id: number,) => {




  return `/api/expenses/${id}`
}

/**
 * @summary Delete an expense
 */
export const deleteExpense = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteExpenseUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteExpenseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExpense>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteExpense>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteExpense'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteExpense>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteExpense(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteExpenseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteExpense>>>

    export type DeleteExpenseMutationError = ErrorType<unknown>

    /**
 * @summary Delete an expense
 */
export const useDeleteExpense = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExpense>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteExpense>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteExpenseMutationOptions(options));
    }

export const getListBudgetOverviewUrl = (params: ListBudgetOverviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/budgets?${stringifiedParams}` : `/api/budgets`
}

/**
 * @summary Get monthly budgets, actuals, and dimension options
 */
export const listBudgetOverview = async (params: ListBudgetOverviewParams, options?: RequestInit): Promise<BudgetOverview> => {

  return customFetch<BudgetOverview>(getListBudgetOverviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBudgetOverviewQueryKey = (params?: ListBudgetOverviewParams,) => {
    return [
    `/api/budgets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListBudgetOverviewQueryOptions = <TData = Awaited<ReturnType<typeof listBudgetOverview>>, TError = ErrorType<void>>(params: ListBudgetOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBudgetOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBudgetOverviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBudgetOverview>>> = ({ signal }) => listBudgetOverview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBudgetOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBudgetOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof listBudgetOverview>>>
export type ListBudgetOverviewQueryError = ErrorType<void>


/**
 * @summary Get monthly budgets, actuals, and dimension options
 */

export function useListBudgetOverview<TData = Awaited<ReturnType<typeof listBudgetOverview>>, TError = ErrorType<void>>(
 params: ListBudgetOverviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBudgetOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBudgetOverviewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpsertBudgetTargetUrl = () => {




  return `/api/budgets`
}

/**
 * @summary Create or update a monthly target
 */
export const upsertBudgetTarget = async (budgetTargetInput: BudgetTargetInput, options?: RequestInit): Promise<BudgetVariance> => {

  return customFetch<BudgetVariance>(getUpsertBudgetTargetUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(budgetTargetInput)
  }
);}




export const getUpsertBudgetTargetMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertBudgetTarget>>, TError,{data: BodyType<BudgetTargetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertBudgetTarget>>, TError,{data: BodyType<BudgetTargetInput>}, TContext> => {

const mutationKey = ['upsertBudgetTarget'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertBudgetTarget>>, {data: BodyType<BudgetTargetInput>}> = (props) => {
          const {data} = props ?? {};

          return  upsertBudgetTarget(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertBudgetTargetMutationResult = NonNullable<Awaited<ReturnType<typeof upsertBudgetTarget>>>
    export type UpsertBudgetTargetMutationBody = BodyType<BudgetTargetInput>
    export type UpsertBudgetTargetMutationError = ErrorType<void>

    /**
 * @summary Create or update a monthly target
 */
export const useUpsertBudgetTarget = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertBudgetTarget>>, TError,{data: BodyType<BudgetTargetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertBudgetTarget>>,
        TError,
        {data: BodyType<BudgetTargetInput>},
        TContext
      > => {
      return useMutation(getUpsertBudgetTargetMutationOptions(options));
    }

export const getDeleteBudgetTargetUrl = (id: number,) => {




  return `/api/budgets/targets/${id}`
}

/**
 * @summary Delete a monthly target
 */
export const deleteBudgetTarget = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteBudgetTargetUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteBudgetTargetMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBudgetTarget>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBudgetTarget>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteBudgetTarget'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBudgetTarget>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteBudgetTarget(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBudgetTargetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBudgetTarget>>>

    export type DeleteBudgetTargetMutationError = ErrorType<void>

    /**
 * @summary Delete a monthly target
 */
export const useDeleteBudgetTarget = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBudgetTarget>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteBudgetTarget>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteBudgetTargetMutationOptions(options));
    }

export const getListBankReconciliationImportsUrl = () => {




  return `/api/accounting/bank-reconciliation/imports`
}

/**
 * @summary List imported bank statements for the current store
 */
export const listBankReconciliationImports = async ( options?: RequestInit): Promise<BankReconciliationImportList> => {

  return customFetch<BankReconciliationImportList>(getListBankReconciliationImportsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBankReconciliationImportsQueryKey = () => {
    return [
    `/api/accounting/bank-reconciliation/imports`
    ] as const;
    }


export const getListBankReconciliationImportsQueryOptions = <TData = Awaited<ReturnType<typeof listBankReconciliationImports>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankReconciliationImports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBankReconciliationImportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBankReconciliationImports>>> = ({ signal }) => listBankReconciliationImports({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBankReconciliationImports>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBankReconciliationImportsQueryResult = NonNullable<Awaited<ReturnType<typeof listBankReconciliationImports>>>
export type ListBankReconciliationImportsQueryError = ErrorType<unknown>


/**
 * @summary List imported bank statements for the current store
 */

export function useListBankReconciliationImports<TData = Awaited<ReturnType<typeof listBankReconciliationImports>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankReconciliationImports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBankReconciliationImportsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBankReconciliationImportUrl = () => {




  return `/api/accounting/bank-reconciliation/imports`
}

/**
 * @summary Import normalized transactions from a bank statement CSV
 */
export const createBankReconciliationImport = async (bankReconciliationImportInput: BankReconciliationImportInput, options?: RequestInit): Promise<BankReconciliationImport> => {

  return customFetch<BankReconciliationImport>(getCreateBankReconciliationImportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bankReconciliationImportInput)
  }
);}




export const getCreateBankReconciliationImportMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBankReconciliationImport>>, TError,{data: BodyType<BankReconciliationImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBankReconciliationImport>>, TError,{data: BodyType<BankReconciliationImportInput>}, TContext> => {

const mutationKey = ['createBankReconciliationImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBankReconciliationImport>>, {data: BodyType<BankReconciliationImportInput>}> = (props) => {
          const {data} = props ?? {};

          return  createBankReconciliationImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBankReconciliationImportMutationResult = NonNullable<Awaited<ReturnType<typeof createBankReconciliationImport>>>
    export type CreateBankReconciliationImportMutationBody = BodyType<BankReconciliationImportInput>
    export type CreateBankReconciliationImportMutationError = ErrorType<void>

    /**
 * @summary Import normalized transactions from a bank statement CSV
 */
export const useCreateBankReconciliationImport = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBankReconciliationImport>>, TError,{data: BodyType<BankReconciliationImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBankReconciliationImport>>,
        TError,
        {data: BodyType<BankReconciliationImportInput>},
        TContext
      > => {
      return useMutation(getCreateBankReconciliationImportMutationOptions(options));
    }

export const getListBankReconciliationTransactionsUrl = (importId: number,) => {




  return `/api/accounting/bank-reconciliation/imports/${importId}/transactions`
}

/**
 * @summary List transactions in an imported statement
 */
export const listBankReconciliationTransactions = async (importId: number, options?: RequestInit): Promise<BankReconciliationTransactionList> => {

  return customFetch<BankReconciliationTransactionList>(getListBankReconciliationTransactionsUrl(importId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBankReconciliationTransactionsQueryKey = (importId: number,) => {
    return [
    `/api/accounting/bank-reconciliation/imports/${importId}/transactions`
    ] as const;
    }


export const getListBankReconciliationTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof listBankReconciliationTransactions>>, TError = ErrorType<unknown>>(importId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankReconciliationTransactions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBankReconciliationTransactionsQueryKey(importId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBankReconciliationTransactions>>> = ({ signal }) => listBankReconciliationTransactions(importId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: importId !== null && importId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBankReconciliationTransactions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBankReconciliationTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof listBankReconciliationTransactions>>>
export type ListBankReconciliationTransactionsQueryError = ErrorType<unknown>


/**
 * @summary List transactions in an imported statement
 */

export function useListBankReconciliationTransactions<TData = Awaited<ReturnType<typeof listBankReconciliationTransactions>>, TError = ErrorType<unknown>>(
 importId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankReconciliationTransactions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBankReconciliationTransactionsQueryOptions(importId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListBankReconciliationCandidatesUrl = (transactionId: number,) => {




  return `/api/accounting/bank-reconciliation/transactions/${transactionId}/candidates`
}

/**
 * @summary Find exact-amount internal records near a bank transaction date
 */
export const listBankReconciliationCandidates = async (transactionId: number, options?: RequestInit): Promise<BankReconciliationCandidateList> => {

  return customFetch<BankReconciliationCandidateList>(getListBankReconciliationCandidatesUrl(transactionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBankReconciliationCandidatesQueryKey = (transactionId: number,) => {
    return [
    `/api/accounting/bank-reconciliation/transactions/${transactionId}/candidates`
    ] as const;
    }


export const getListBankReconciliationCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof listBankReconciliationCandidates>>, TError = ErrorType<unknown>>(transactionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankReconciliationCandidates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBankReconciliationCandidatesQueryKey(transactionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBankReconciliationCandidates>>> = ({ signal }) => listBankReconciliationCandidates(transactionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: transactionId !== null && transactionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBankReconciliationCandidates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBankReconciliationCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof listBankReconciliationCandidates>>>
export type ListBankReconciliationCandidatesQueryError = ErrorType<unknown>


/**
 * @summary Find exact-amount internal records near a bank transaction date
 */

export function useListBankReconciliationCandidates<TData = Awaited<ReturnType<typeof listBankReconciliationCandidates>>, TError = ErrorType<unknown>>(
 transactionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankReconciliationCandidates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBankReconciliationCandidatesQueryOptions(transactionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getMatchBankReconciliationTransactionUrl = (transactionId: number,) => {




  return `/api/accounting/bank-reconciliation/transactions/${transactionId}/match`
}

/**
 * @summary Match a bank transaction to one RetailPulse record
 */
export const matchBankReconciliationTransaction = async (transactionId: number,
    bankReconciliationMatchInput: BankReconciliationMatchInput, options?: RequestInit): Promise<BankReconciliationTransaction> => {

  return customFetch<BankReconciliationTransaction>(getMatchBankReconciliationTransactionUrl(transactionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bankReconciliationMatchInput)
  }
);}




export const getMatchBankReconciliationTransactionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchBankReconciliationTransaction>>, TError,{transactionId: number;data: BodyType<BankReconciliationMatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof matchBankReconciliationTransaction>>, TError,{transactionId: number;data: BodyType<BankReconciliationMatchInput>}, TContext> => {

const mutationKey = ['matchBankReconciliationTransaction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchBankReconciliationTransaction>>, {transactionId: number;data: BodyType<BankReconciliationMatchInput>}> = (props) => {
          const {transactionId,data} = props ?? {};

          return  matchBankReconciliationTransaction(transactionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MatchBankReconciliationTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof matchBankReconciliationTransaction>>>
    export type MatchBankReconciliationTransactionMutationBody = BodyType<BankReconciliationMatchInput>
    export type MatchBankReconciliationTransactionMutationError = ErrorType<void>

    /**
 * @summary Match a bank transaction to one RetailPulse record
 */
export const useMatchBankReconciliationTransaction = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchBankReconciliationTransaction>>, TError,{transactionId: number;data: BodyType<BankReconciliationMatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof matchBankReconciliationTransaction>>,
        TError,
        {transactionId: number;data: BodyType<BankReconciliationMatchInput>},
        TContext
      > => {
      return useMutation(getMatchBankReconciliationTransactionMutationOptions(options));
    }

export const getUnmatchBankReconciliationTransactionUrl = (transactionId: number,) => {




  return `/api/accounting/bank-reconciliation/transactions/${transactionId}/match`
}

/**
 * @summary Remove an incorrect match without deleting its audit history
 */
export const unmatchBankReconciliationTransaction = async (transactionId: number, options?: RequestInit): Promise<BankReconciliationTransaction> => {

  return customFetch<BankReconciliationTransaction>(getUnmatchBankReconciliationTransactionUrl(transactionId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getUnmatchBankReconciliationTransactionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unmatchBankReconciliationTransaction>>, TError,{transactionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unmatchBankReconciliationTransaction>>, TError,{transactionId: number}, TContext> => {

const mutationKey = ['unmatchBankReconciliationTransaction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unmatchBankReconciliationTransaction>>, {transactionId: number}> = (props) => {
          const {transactionId} = props ?? {};

          return  unmatchBankReconciliationTransaction(transactionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnmatchBankReconciliationTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof unmatchBankReconciliationTransaction>>>

    export type UnmatchBankReconciliationTransactionMutationError = ErrorType<unknown>

    /**
 * @summary Remove an incorrect match without deleting its audit history
 */
export const useUnmatchBankReconciliationTransaction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unmatchBankReconciliationTransaction>>, TError,{transactionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unmatchBankReconciliationTransaction>>,
        TError,
        {transactionId: number},
        TContext
      > => {
      return useMutation(getUnmatchBankReconciliationTransactionMutationOptions(options));
    }

export const getReviewBankReconciliationTransactionUrl = (transactionId: number,) => {




  return `/api/accounting/bank-reconciliation/transactions/${transactionId}/review`
}

/**
 * @summary Mark a non-one-to-one or external bank line as reviewed with a note
 */
export const reviewBankReconciliationTransaction = async (transactionId: number,
    bankReconciliationReviewInput: BankReconciliationReviewInput, options?: RequestInit): Promise<BankReconciliationTransaction> => {

  return customFetch<BankReconciliationTransaction>(getReviewBankReconciliationTransactionUrl(transactionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bankReconciliationReviewInput)
  }
);}




export const getReviewBankReconciliationTransactionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewBankReconciliationTransaction>>, TError,{transactionId: number;data: BodyType<BankReconciliationReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewBankReconciliationTransaction>>, TError,{transactionId: number;data: BodyType<BankReconciliationReviewInput>}, TContext> => {

const mutationKey = ['reviewBankReconciliationTransaction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewBankReconciliationTransaction>>, {transactionId: number;data: BodyType<BankReconciliationReviewInput>}> = (props) => {
          const {transactionId,data} = props ?? {};

          return  reviewBankReconciliationTransaction(transactionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewBankReconciliationTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof reviewBankReconciliationTransaction>>>
    export type ReviewBankReconciliationTransactionMutationBody = BodyType<BankReconciliationReviewInput>
    export type ReviewBankReconciliationTransactionMutationError = ErrorType<unknown>

    /**
 * @summary Mark a non-one-to-one or external bank line as reviewed with a note
 */
export const useReviewBankReconciliationTransaction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewBankReconciliationTransaction>>, TError,{transactionId: number;data: BodyType<BankReconciliationReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviewBankReconciliationTransaction>>,
        TError,
        {transactionId: number;data: BodyType<BankReconciliationReviewInput>},
        TContext
      > => {
      return useMutation(getReviewBankReconciliationTransactionMutationOptions(options));
    }

export const getUnreviewBankReconciliationTransactionUrl = (transactionId: number,) => {




  return `/api/accounting/bank-reconciliation/transactions/${transactionId}/review`
}

/**
 * @summary Return a reviewed bank line to the unmatched queue
 */
export const unreviewBankReconciliationTransaction = async (transactionId: number, options?: RequestInit): Promise<BankReconciliationTransaction> => {

  return customFetch<BankReconciliationTransaction>(getUnreviewBankReconciliationTransactionUrl(transactionId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getUnreviewBankReconciliationTransactionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unreviewBankReconciliationTransaction>>, TError,{transactionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unreviewBankReconciliationTransaction>>, TError,{transactionId: number}, TContext> => {

const mutationKey = ['unreviewBankReconciliationTransaction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unreviewBankReconciliationTransaction>>, {transactionId: number}> = (props) => {
          const {transactionId} = props ?? {};

          return  unreviewBankReconciliationTransaction(transactionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnreviewBankReconciliationTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof unreviewBankReconciliationTransaction>>>

    export type UnreviewBankReconciliationTransactionMutationError = ErrorType<unknown>

    /**
 * @summary Return a reviewed bank line to the unmatched queue
 */
export const useUnreviewBankReconciliationTransaction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unreviewBankReconciliationTransaction>>, TError,{transactionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unreviewBankReconciliationTransaction>>,
        TError,
        {transactionId: number},
        TContext
      > => {
      return useMutation(getUnreviewBankReconciliationTransactionMutationOptions(options));
    }

export const getListReturnsUrl = () => {




  return `/api/returns`
}

/**
 * @summary List returns/refunds
 */
export const listReturns = async ( options?: RequestInit): Promise<Return[]> => {

  return customFetch<Return[]>(getListReturnsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReturnsQueryKey = () => {
    return [
    `/api/returns`
    ] as const;
    }


export const getListReturnsQueryOptions = <TData = Awaited<ReturnType<typeof listReturns>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReturnsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReturns>>> = ({ signal }) => listReturns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReturns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListReturnsQueryResult = NonNullable<Awaited<ReturnType<typeof listReturns>>>
export type ListReturnsQueryError = ErrorType<unknown>


/**
 * @summary List returns/refunds
 */

export function useListReturns<TData = Awaited<ReturnType<typeof listReturns>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReturns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListReturnsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateReturnUrl = () => {




  return `/api/returns`
}

/**
 * @summary Process a return or refund
 */
export const createReturn = async (returnInput: ReturnInput, options?: RequestInit): Promise<Return> => {

  return customFetch<Return>(getCreateReturnUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(returnInput)
  }
);}




export const getCreateReturnMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReturn>>, TError,{data: BodyType<ReturnInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createReturn>>, TError,{data: BodyType<ReturnInput>}, TContext> => {

const mutationKey = ['createReturn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReturn>>, {data: BodyType<ReturnInput>}> = (props) => {
          const {data} = props ?? {};

          return  createReturn(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReturnMutationResult = NonNullable<Awaited<ReturnType<typeof createReturn>>>
    export type CreateReturnMutationBody = BodyType<ReturnInput>
    export type CreateReturnMutationError = ErrorType<unknown>

    /**
 * @summary Process a return or refund
 */
export const useCreateReturn = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReturn>>, TError,{data: BodyType<ReturnInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createReturn>>,
        TError,
        {data: BodyType<ReturnInput>},
        TContext
      > => {
      return useMutation(getCreateReturnMutationOptions(options));
    }

export const getGetReturnUrl = (id: number,) => {




  return `/api/returns/${id}`
}

/**
 * @summary Get a return record
 */
export const getReturn = async (id: number, options?: RequestInit): Promise<Return> => {

  return customFetch<Return>(getGetReturnUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReturnQueryKey = (id: number,) => {
    return [
    `/api/returns/${id}`
    ] as const;
    }


export const getGetReturnQueryOptions = <TData = Awaited<ReturnType<typeof getReturn>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReturn>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReturnQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReturn>>> = ({ signal }) => getReturn(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReturn>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReturnQueryResult = NonNullable<Awaited<ReturnType<typeof getReturn>>>
export type GetReturnQueryError = ErrorType<unknown>


/**
 * @summary Get a return record
 */

export function useGetReturn<TData = Awaited<ReturnType<typeof getReturn>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReturn>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReturnQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetProductSalesReportUrl = (params: GetProductSalesReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/product-sales?${stringifiedParams}` : `/api/reports/product-sales`
}

/**
 * @summary Get gross and net product sales
 */
export const getProductSalesReport = async (params: GetProductSalesReportParams, options?: RequestInit): Promise<ProductSalesReportResponse> => {

  return customFetch<ProductSalesReportResponse>(getGetProductSalesReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductSalesReportQueryKey = (params?: GetProductSalesReportParams,) => {
    return [
    `/api/reports/product-sales`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProductSalesReportQueryOptions = <TData = Awaited<ReturnType<typeof getProductSalesReport>>, TError = ErrorType<unknown>>(params: GetProductSalesReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductSalesReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductSalesReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductSalesReport>>> = ({ signal }) => getProductSalesReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductSalesReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductSalesReportQueryResult = NonNullable<Awaited<ReturnType<typeof getProductSalesReport>>>
export type GetProductSalesReportQueryError = ErrorType<unknown>


/**
 * @summary Get gross and net product sales
 */

export function useGetProductSalesReport<TData = Awaited<ReturnType<typeof getProductSalesReport>>, TError = ErrorType<unknown>>(
 params: GetProductSalesReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductSalesReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductSalesReportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetDashboardSummaryUrl = (params?: GetDashboardSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/summary?${stringifiedParams}` : `/api/dashboard/summary`
}

/**
 * @summary Get dashboard KPI summary
 */
export const getDashboardSummary = async (params?: GetDashboardSummaryParams, options?: RequestInit): Promise<DashboardSummary> => {

  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardSummaryQueryKey = (params?: GetDashboardSummaryParams,) => {
    return [
    `/api/dashboard/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>(params?: GetDashboardSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSummary>>> = ({ signal }) => getDashboardSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardSummary>>>
export type GetDashboardSummaryQueryError = ErrorType<unknown>


/**
 * @summary Get dashboard KPI summary
 */

export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>(
 params?: GetDashboardSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetSalesChartUrl = (params?: GetSalesChartParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/sales-chart?${stringifiedParams}` : `/api/dashboard/sales-chart`
}

/**
 * @summary Get daily sales data for chart (last 30 days)
 */
export const getSalesChart = async (params?: GetSalesChartParams, options?: RequestInit): Promise<SalesChartPoint[]> => {

  return customFetch<SalesChartPoint[]>(getGetSalesChartUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSalesChartQueryKey = (params?: GetSalesChartParams,) => {
    return [
    `/api/dashboard/sales-chart`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSalesChartQueryOptions = <TData = Awaited<ReturnType<typeof getSalesChart>>, TError = ErrorType<unknown>>(params?: GetSalesChartParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesChart>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSalesChartQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesChart>>> = ({ signal }) => getSalesChart(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSalesChart>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSalesChartQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesChart>>>
export type GetSalesChartQueryError = ErrorType<unknown>


/**
 * @summary Get daily sales data for chart (last 30 days)
 */

export function useGetSalesChart<TData = Awaited<ReturnType<typeof getSalesChart>>, TError = ErrorType<unknown>>(
 params?: GetSalesChartParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSalesChart>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSalesChartQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetTopProductsUrl = (params?: GetTopProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/top-products?${stringifiedParams}` : `/api/dashboard/top-products`
}

/**
 * @summary Get top-selling products
 */
export const getTopProducts = async (params?: GetTopProductsParams, options?: RequestInit): Promise<TopProduct[]> => {

  return customFetch<TopProduct[]>(getGetTopProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTopProductsQueryKey = (params?: GetTopProductsParams,) => {
    return [
    `/api/dashboard/top-products`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTopProductsQueryOptions = <TData = Awaited<ReturnType<typeof getTopProducts>>, TError = ErrorType<unknown>>(params?: GetTopProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTopProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTopProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopProducts>>> = ({ signal }) => getTopProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTopProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTopProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getTopProducts>>>
export type GetTopProductsQueryError = ErrorType<unknown>


/**
 * @summary Get top-selling products
 */

export function useGetTopProducts<TData = Awaited<ReturnType<typeof getTopProducts>>, TError = ErrorType<unknown>>(
 params?: GetTopProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTopProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTopProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetProfitLossUrl = (params?: GetProfitLossParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/profit-loss?${stringifiedParams}` : `/api/dashboard/profit-loss`
}

/**
 * @summary Get profit and loss report
 */
export const getProfitLoss = async (params?: GetProfitLossParams, options?: RequestInit): Promise<ProfitLossReport> => {

  return customFetch<ProfitLossReport>(getGetProfitLossUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProfitLossQueryKey = (params?: GetProfitLossParams,) => {
    return [
    `/api/dashboard/profit-loss`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProfitLossQueryOptions = <TData = Awaited<ReturnType<typeof getProfitLoss>>, TError = ErrorType<unknown>>(params?: GetProfitLossParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfitLoss>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfitLossQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfitLoss>>> = ({ signal }) => getProfitLoss(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfitLoss>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProfitLossQueryResult = NonNullable<Awaited<ReturnType<typeof getProfitLoss>>>
export type GetProfitLossQueryError = ErrorType<unknown>


/**
 * @summary Get profit and loss report
 */

export function useGetProfitLoss<TData = Awaited<ReturnType<typeof getProfitLoss>>, TError = ErrorType<unknown>>(
 params?: GetProfitLossParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfitLoss>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProfitLossQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetDailyCloseUrl = (params?: GetDailyCloseParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/daily-close?${stringifiedParams}` : `/api/dashboard/daily-close`
}

/**
 * @summary Get daily close figures
 */
export const getDailyClose = async (params?: GetDailyCloseParams, options?: RequestInit): Promise<DailyCloseReport> => {

  return customFetch<DailyCloseReport>(getGetDailyCloseUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDailyCloseQueryKey = (params?: GetDailyCloseParams,) => {
    return [
    `/api/dashboard/daily-close`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDailyCloseQueryOptions = <TData = Awaited<ReturnType<typeof getDailyClose>>, TError = ErrorType<unknown>>(params?: GetDailyCloseParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDailyClose>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDailyCloseQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDailyClose>>> = ({ signal }) => getDailyClose(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDailyClose>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDailyCloseQueryResult = NonNullable<Awaited<ReturnType<typeof getDailyClose>>>
export type GetDailyCloseQueryError = ErrorType<unknown>


/**
 * @summary Get daily close figures
 */

export function useGetDailyClose<TData = Awaited<ReturnType<typeof getDailyClose>>, TError = ErrorType<unknown>>(
 params?: GetDailyCloseParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDailyClose>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDailyCloseQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetExpenseBreakdownUrl = (params?: GetExpenseBreakdownParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/expense-breakdown?${stringifiedParams}` : `/api/dashboard/expense-breakdown`
}

/**
 * @summary Get expense breakdown by category
 */
export const getExpenseBreakdown = async (params?: GetExpenseBreakdownParams, options?: RequestInit): Promise<ExpenseBreakdown[]> => {

  return customFetch<ExpenseBreakdown[]>(getGetExpenseBreakdownUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExpenseBreakdownQueryKey = (params?: GetExpenseBreakdownParams,) => {
    return [
    `/api/dashboard/expense-breakdown`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetExpenseBreakdownQueryOptions = <TData = Awaited<ReturnType<typeof getExpenseBreakdown>>, TError = ErrorType<unknown>>(params?: GetExpenseBreakdownParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenseBreakdown>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExpenseBreakdownQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExpenseBreakdown>>> = ({ signal }) => getExpenseBreakdown(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExpenseBreakdown>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExpenseBreakdownQueryResult = NonNullable<Awaited<ReturnType<typeof getExpenseBreakdown>>>
export type GetExpenseBreakdownQueryError = ErrorType<unknown>


/**
 * @summary Get expense breakdown by category
 */

export function useGetExpenseBreakdown<TData = Awaited<ReturnType<typeof getExpenseBreakdown>>, TError = ErrorType<unknown>>(
 params?: GetExpenseBreakdownParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExpenseBreakdown>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExpenseBreakdownQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRequestPartnerAdImageUploadUrlUrl = () => {




  return `/api/storage/uploads/partner-ad-image/request-url`
}

/**
 * @summary Request a store-scoped upload URL for a partner ad flyer
 */
export const requestPartnerAdImageUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: RequestInit): Promise<UploadUrlResponse> => {

  return customFetch<UploadUrlResponse>(getRequestPartnerAdImageUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadUrlRequest)
  }
);}




export const getRequestPartnerAdImageUploadUrlMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPartnerAdImageUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestPartnerAdImageUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext> => {

const mutationKey = ['requestPartnerAdImageUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPartnerAdImageUploadUrl>>, {data: BodyType<UploadUrlRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestPartnerAdImageUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestPartnerAdImageUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestPartnerAdImageUploadUrl>>>
    export type RequestPartnerAdImageUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestPartnerAdImageUploadUrlMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Request a store-scoped upload URL for a partner ad flyer
 */
export const useRequestPartnerAdImageUploadUrl = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPartnerAdImageUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestPartnerAdImageUploadUrl>>,
        TError,
        {data: BodyType<UploadUrlRequest>},
        TContext
      > => {
      return useMutation(getRequestPartnerAdImageUploadUrlMutationOptions(options));
    }

export const getRequestUploadUrlUrl = () => {




  return `/api/storage/uploads/request-url`
}

/**
 * @summary Request a presigned URL for file upload
 */
export const requestUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: RequestInit): Promise<UploadUrlResponse> => {

  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadUrlRequest)
  }
);}




export const getRequestUploadUrlMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext> => {

const mutationKey = ['requestUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUploadUrl>>, {data: BodyType<UploadUrlRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestUploadUrl>>>
    export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestUploadUrlMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestUploadUrl>>,
        TError,
        {data: BodyType<UploadUrlRequest>},
        TContext
      > => {
      return useMutation(getRequestUploadUrlMutationOptions(options));
    }

export const getGetStorageObjectUrl = (objectPath: string,) => {




  return `/api/storage/objects/${objectPath}`
}

/**
 * @summary Serve a stored object
 */
export const getStorageObject = async (objectPath: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetStorageObjectUrl(objectPath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorageObjectQueryKey = (objectPath: string,) => {
    return [
    `/api/storage/objects/${objectPath}`
    ] as const;
    }


export const getGetStorageObjectQueryOptions = <TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageObject>>> = ({ signal }) => getStorageObject(objectPath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: objectPath !== null && objectPath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorageObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getStorageObject>>>
export type GetStorageObjectQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Serve a stored object
 */

export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(
 objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorageObjectQueryOptions(objectPath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListGiftRegistriesUrl = (params?: ListGiftRegistriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gift-registry?${stringifiedParams}` : `/api/gift-registry`
}

/**
 * @summary List all gift registries
 */
export const listGiftRegistries = async (params?: ListGiftRegistriesParams, options?: RequestInit): Promise<GiftRegistry[]> => {

  return customFetch<GiftRegistry[]>(getListGiftRegistriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGiftRegistriesQueryKey = (params?: ListGiftRegistriesParams,) => {
    return [
    `/api/gift-registry`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGiftRegistriesQueryOptions = <TData = Awaited<ReturnType<typeof listGiftRegistries>>, TError = ErrorType<unknown>>(params?: ListGiftRegistriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGiftRegistries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGiftRegistriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGiftRegistries>>> = ({ signal }) => listGiftRegistries(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGiftRegistries>>, TError, TData> & { queryKey: QueryKey }
}

export type ListGiftRegistriesQueryResult = NonNullable<Awaited<ReturnType<typeof listGiftRegistries>>>
export type ListGiftRegistriesQueryError = ErrorType<unknown>


/**
 * @summary List all gift registries
 */

export function useListGiftRegistries<TData = Awaited<ReturnType<typeof listGiftRegistries>>, TError = ErrorType<unknown>>(
 params?: ListGiftRegistriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGiftRegistries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListGiftRegistriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateGiftRegistryUrl = () => {




  return `/api/gift-registry`
}

/**
 * @summary Create a gift registry
 */
export const createGiftRegistry = async (createGiftRegistryRequest: CreateGiftRegistryRequest, options?: RequestInit): Promise<GiftRegistry> => {

  return customFetch<GiftRegistry>(getCreateGiftRegistryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createGiftRegistryRequest)
  }
);}




export const getCreateGiftRegistryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGiftRegistry>>, TError,{data: BodyType<CreateGiftRegistryRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createGiftRegistry>>, TError,{data: BodyType<CreateGiftRegistryRequest>}, TContext> => {

const mutationKey = ['createGiftRegistry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGiftRegistry>>, {data: BodyType<CreateGiftRegistryRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createGiftRegistry(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGiftRegistryMutationResult = NonNullable<Awaited<ReturnType<typeof createGiftRegistry>>>
    export type CreateGiftRegistryMutationBody = BodyType<CreateGiftRegistryRequest>
    export type CreateGiftRegistryMutationError = ErrorType<unknown>

    /**
 * @summary Create a gift registry
 */
export const useCreateGiftRegistry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGiftRegistry>>, TError,{data: BodyType<CreateGiftRegistryRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createGiftRegistry>>,
        TError,
        {data: BodyType<CreateGiftRegistryRequest>},
        TContext
      > => {
      return useMutation(getCreateGiftRegistryMutationOptions(options));
    }

export const getLookupGiftRegistryUrl = (code: string,) => {




  return `/api/gift-registry/lookup/${code}`
}

/**
 * @summary Look up a registry by code
 */
export const lookupGiftRegistry = async (code: string, options?: RequestInit): Promise<GiftRegistryDetail> => {

  return customFetch<GiftRegistryDetail>(getLookupGiftRegistryUrl(code),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLookupGiftRegistryQueryKey = (code: string,) => {
    return [
    `/api/gift-registry/lookup/${code}`
    ] as const;
    }


export const getLookupGiftRegistryQueryOptions = <TData = Awaited<ReturnType<typeof lookupGiftRegistry>>, TError = ErrorType<ErrorEnvelope>>(code: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof lookupGiftRegistry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLookupGiftRegistryQueryKey(code);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lookupGiftRegistry>>> = ({ signal }) => lookupGiftRegistry(code, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lookupGiftRegistry>>, TError, TData> & { queryKey: QueryKey }
}

export type LookupGiftRegistryQueryResult = NonNullable<Awaited<ReturnType<typeof lookupGiftRegistry>>>
export type LookupGiftRegistryQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Look up a registry by code
 */

export function useLookupGiftRegistry<TData = Awaited<ReturnType<typeof lookupGiftRegistry>>, TError = ErrorType<ErrorEnvelope>>(
 code: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof lookupGiftRegistry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getLookupGiftRegistryQueryOptions(code,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetGiftRegistryUrl = (id: number,) => {




  return `/api/gift-registry/${id}`
}

/**
 * @summary Get a registry with its items
 */
export const getGiftRegistry = async (id: number, options?: RequestInit): Promise<GiftRegistryDetail> => {

  return customFetch<GiftRegistryDetail>(getGetGiftRegistryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGiftRegistryQueryKey = (id: number,) => {
    return [
    `/api/gift-registry/${id}`
    ] as const;
    }


export const getGetGiftRegistryQueryOptions = <TData = Awaited<ReturnType<typeof getGiftRegistry>>, TError = ErrorType<ErrorEnvelope>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGiftRegistry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGiftRegistryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGiftRegistry>>> = ({ signal }) => getGiftRegistry(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGiftRegistry>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGiftRegistryQueryResult = NonNullable<Awaited<ReturnType<typeof getGiftRegistry>>>
export type GetGiftRegistryQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Get a registry with its items
 */

export function useGetGiftRegistry<TData = Awaited<ReturnType<typeof getGiftRegistry>>, TError = ErrorType<ErrorEnvelope>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGiftRegistry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGiftRegistryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateGiftRegistryUrl = (id: number,) => {




  return `/api/gift-registry/${id}`
}

/**
 * @summary Update a registry
 */
export const updateGiftRegistry = async (id: number,
    createGiftRegistryRequest: CreateGiftRegistryRequest, options?: RequestInit): Promise<GiftRegistry> => {

  return customFetch<GiftRegistry>(getUpdateGiftRegistryUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createGiftRegistryRequest)
  }
);}




export const getUpdateGiftRegistryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGiftRegistry>>, TError,{id: number;data: BodyType<CreateGiftRegistryRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGiftRegistry>>, TError,{id: number;data: BodyType<CreateGiftRegistryRequest>}, TContext> => {

const mutationKey = ['updateGiftRegistry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGiftRegistry>>, {id: number;data: BodyType<CreateGiftRegistryRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateGiftRegistry(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateGiftRegistryMutationResult = NonNullable<Awaited<ReturnType<typeof updateGiftRegistry>>>
    export type UpdateGiftRegistryMutationBody = BodyType<CreateGiftRegistryRequest>
    export type UpdateGiftRegistryMutationError = ErrorType<unknown>

    /**
 * @summary Update a registry
 */
export const useUpdateGiftRegistry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGiftRegistry>>, TError,{id: number;data: BodyType<CreateGiftRegistryRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateGiftRegistry>>,
        TError,
        {id: number;data: BodyType<CreateGiftRegistryRequest>},
        TContext
      > => {
      return useMutation(getUpdateGiftRegistryMutationOptions(options));
    }

export const getDeleteGiftRegistryUrl = (id: number,) => {




  return `/api/gift-registry/${id}`
}

/**
 * @summary Delete a registry
 */
export const deleteGiftRegistry = async (id: number, options?: RequestInit): Promise<DeleteGiftRegistry200> => {

  return customFetch<DeleteGiftRegistry200>(getDeleteGiftRegistryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteGiftRegistryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGiftRegistry>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGiftRegistry>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteGiftRegistry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGiftRegistry>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteGiftRegistry(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteGiftRegistryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGiftRegistry>>>

    export type DeleteGiftRegistryMutationError = ErrorType<unknown>

    /**
 * @summary Delete a registry
 */
export const useDeleteGiftRegistry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGiftRegistry>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteGiftRegistry>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteGiftRegistryMutationOptions(options));
    }

export const getAddGiftRegistryItemUrl = (id: number,) => {




  return `/api/gift-registry/${id}/items`
}

/**
 * @summary Add an item to a registry
 */
export const addGiftRegistryItem = async (id: number,
    addGiftRegistryItemRequest: AddGiftRegistryItemRequest, options?: RequestInit): Promise<GiftRegistryItem> => {

  return customFetch<GiftRegistryItem>(getAddGiftRegistryItemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addGiftRegistryItemRequest)
  }
);}




export const getAddGiftRegistryItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addGiftRegistryItem>>, TError,{id: number;data: BodyType<AddGiftRegistryItemRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addGiftRegistryItem>>, TError,{id: number;data: BodyType<AddGiftRegistryItemRequest>}, TContext> => {

const mutationKey = ['addGiftRegistryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addGiftRegistryItem>>, {id: number;data: BodyType<AddGiftRegistryItemRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  addGiftRegistryItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddGiftRegistryItemMutationResult = NonNullable<Awaited<ReturnType<typeof addGiftRegistryItem>>>
    export type AddGiftRegistryItemMutationBody = BodyType<AddGiftRegistryItemRequest>
    export type AddGiftRegistryItemMutationError = ErrorType<unknown>

    /**
 * @summary Add an item to a registry
 */
export const useAddGiftRegistryItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addGiftRegistryItem>>, TError,{id: number;data: BodyType<AddGiftRegistryItemRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addGiftRegistryItem>>,
        TError,
        {id: number;data: BodyType<AddGiftRegistryItemRequest>},
        TContext
      > => {
      return useMutation(getAddGiftRegistryItemMutationOptions(options));
    }

export const getUpdateGiftRegistryItemUrl = (id: number,
    itemId: number,) => {




  return `/api/gift-registry/${id}/items/${itemId}`
}

/**
 * @summary Update a registry item (e.g. mark fulfilled)
 */
export const updateGiftRegistryItem = async (id: number,
    itemId: number,
    updateGiftRegistryItemRequest: UpdateGiftRegistryItemRequest, options?: RequestInit): Promise<GiftRegistryItem> => {

  return customFetch<GiftRegistryItem>(getUpdateGiftRegistryItemUrl(id,itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateGiftRegistryItemRequest)
  }
);}




export const getUpdateGiftRegistryItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGiftRegistryItem>>, TError,{id: number;itemId: number;data: BodyType<UpdateGiftRegistryItemRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGiftRegistryItem>>, TError,{id: number;itemId: number;data: BodyType<UpdateGiftRegistryItemRequest>}, TContext> => {

const mutationKey = ['updateGiftRegistryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGiftRegistryItem>>, {id: number;itemId: number;data: BodyType<UpdateGiftRegistryItemRequest>}> = (props) => {
          const {id,itemId,data} = props ?? {};

          return  updateGiftRegistryItem(id,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateGiftRegistryItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateGiftRegistryItem>>>
    export type UpdateGiftRegistryItemMutationBody = BodyType<UpdateGiftRegistryItemRequest>
    export type UpdateGiftRegistryItemMutationError = ErrorType<unknown>

    /**
 * @summary Update a registry item (e.g. mark fulfilled)
 */
export const useUpdateGiftRegistryItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGiftRegistryItem>>, TError,{id: number;itemId: number;data: BodyType<UpdateGiftRegistryItemRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateGiftRegistryItem>>,
        TError,
        {id: number;itemId: number;data: BodyType<UpdateGiftRegistryItemRequest>},
        TContext
      > => {
      return useMutation(getUpdateGiftRegistryItemMutationOptions(options));
    }

export const getDeleteGiftRegistryItemUrl = (id: number,
    itemId: number,) => {




  return `/api/gift-registry/${id}/items/${itemId}`
}

/**
 * @summary Remove an item from a registry
 */
export const deleteGiftRegistryItem = async (id: number,
    itemId: number, options?: RequestInit): Promise<DeleteGiftRegistryItem200> => {

  return customFetch<DeleteGiftRegistryItem200>(getDeleteGiftRegistryItemUrl(id,itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteGiftRegistryItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGiftRegistryItem>>, TError,{id: number;itemId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGiftRegistryItem>>, TError,{id: number;itemId: number}, TContext> => {

const mutationKey = ['deleteGiftRegistryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGiftRegistryItem>>, {id: number;itemId: number}> = (props) => {
          const {id,itemId} = props ?? {};

          return  deleteGiftRegistryItem(id,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteGiftRegistryItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGiftRegistryItem>>>

    export type DeleteGiftRegistryItemMutationError = ErrorType<unknown>

    /**
 * @summary Remove an item from a registry
 */
export const useDeleteGiftRegistryItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGiftRegistryItem>>, TError,{id: number;itemId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteGiftRegistryItem>>,
        TError,
        {id: number;itemId: number},
        TContext
      > => {
      return useMutation(getDeleteGiftRegistryItemMutationOptions(options));
    }

export const getListSchoolTermsUrl = () => {




  return `/api/school/terms`
}

/**
 * @summary List academic terms
 */
export const listSchoolTerms = async ( options?: RequestInit): Promise<SchoolTerm[]> => {

  return customFetch<SchoolTerm[]>(getListSchoolTermsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSchoolTermsQueryKey = () => {
    return [
    `/api/school/terms`
    ] as const;
    }


export const getListSchoolTermsQueryOptions = <TData = Awaited<ReturnType<typeof listSchoolTerms>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSchoolTerms>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSchoolTermsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchoolTerms>>> = ({ signal }) => listSchoolTerms({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchoolTerms>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSchoolTermsQueryResult = NonNullable<Awaited<ReturnType<typeof listSchoolTerms>>>
export type ListSchoolTermsQueryError = ErrorType<unknown>


/**
 * @summary List academic terms
 */

export function useListSchoolTerms<TData = Awaited<ReturnType<typeof listSchoolTerms>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSchoolTerms>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSchoolTermsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateSchoolTermUrl = () => {




  return `/api/school/terms`
}

/**
 * @summary Create an academic term
 */
export const createSchoolTerm = async (schoolTermInput: SchoolTermInput, options?: RequestInit): Promise<SchoolTerm> => {

  return customFetch<SchoolTerm>(getCreateSchoolTermUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolTermInput)
  }
);}




export const getCreateSchoolTermMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolTerm>>, TError,{data: BodyType<SchoolTermInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSchoolTerm>>, TError,{data: BodyType<SchoolTermInput>}, TContext> => {

const mutationKey = ['createSchoolTerm'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchoolTerm>>, {data: BodyType<SchoolTermInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSchoolTerm(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSchoolTermMutationResult = NonNullable<Awaited<ReturnType<typeof createSchoolTerm>>>
    export type CreateSchoolTermMutationBody = BodyType<SchoolTermInput>
    export type CreateSchoolTermMutationError = ErrorType<void>

    /**
 * @summary Create an academic term
 */
export const useCreateSchoolTerm = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolTerm>>, TError,{data: BodyType<SchoolTermInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSchoolTerm>>,
        TError,
        {data: BodyType<SchoolTermInput>},
        TContext
      > => {
      return useMutation(getCreateSchoolTermMutationOptions(options));
    }

export const getUpdateSchoolTermUrl = (id: number,) => {




  return `/api/school/terms/${id}`
}

/**
 * @summary Update an academic term
 */
export const updateSchoolTerm = async (id: number,
    schoolTermUpdate: SchoolTermUpdate, options?: RequestInit): Promise<SchoolTerm> => {

  return customFetch<SchoolTerm>(getUpdateSchoolTermUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolTermUpdate)
  }
);}




export const getUpdateSchoolTermMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolTerm>>, TError,{id: number;data: BodyType<SchoolTermUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSchoolTerm>>, TError,{id: number;data: BodyType<SchoolTermUpdate>}, TContext> => {

const mutationKey = ['updateSchoolTerm'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSchoolTerm>>, {id: number;data: BodyType<SchoolTermUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSchoolTerm(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSchoolTermMutationResult = NonNullable<Awaited<ReturnType<typeof updateSchoolTerm>>>
    export type UpdateSchoolTermMutationBody = BodyType<SchoolTermUpdate>
    export type UpdateSchoolTermMutationError = ErrorType<void>

    /**
 * @summary Update an academic term
 */
export const useUpdateSchoolTerm = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolTerm>>, TError,{id: number;data: BodyType<SchoolTermUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSchoolTerm>>,
        TError,
        {id: number;data: BodyType<SchoolTermUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSchoolTermMutationOptions(options));
    }

export const getListSchoolStudentsUrl = (params?: ListSchoolStudentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/school/students?${stringifiedParams}` : `/api/school/students`
}

/**
 * @summary List students and their balances for a selected term
 */
export const listSchoolStudents = async (params?: ListSchoolStudentsParams, options?: RequestInit): Promise<SchoolStudentListResponse> => {

  return customFetch<SchoolStudentListResponse>(getListSchoolStudentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSchoolStudentsQueryKey = (params?: ListSchoolStudentsParams,) => {
    return [
    `/api/school/students`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSchoolStudentsQueryOptions = <TData = Awaited<ReturnType<typeof listSchoolStudents>>, TError = ErrorType<unknown>>(params?: ListSchoolStudentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSchoolStudents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSchoolStudentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchoolStudents>>> = ({ signal }) => listSchoolStudents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchoolStudents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSchoolStudentsQueryResult = NonNullable<Awaited<ReturnType<typeof listSchoolStudents>>>
export type ListSchoolStudentsQueryError = ErrorType<unknown>


/**
 * @summary List students and their balances for a selected term
 */

export function useListSchoolStudents<TData = Awaited<ReturnType<typeof listSchoolStudents>>, TError = ErrorType<unknown>>(
 params?: ListSchoolStudentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSchoolStudents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSchoolStudentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateSchoolStudentUrl = () => {




  return `/api/school/students`
}

/**
 * @summary Add a student and optional primary guardian
 */
export const createSchoolStudent = async (schoolStudentInput: SchoolStudentInput, options?: RequestInit): Promise<SchoolStudent> => {

  return customFetch<SchoolStudent>(getCreateSchoolStudentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolStudentInput)
  }
);}




export const getCreateSchoolStudentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolStudent>>, TError,{data: BodyType<SchoolStudentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSchoolStudent>>, TError,{data: BodyType<SchoolStudentInput>}, TContext> => {

const mutationKey = ['createSchoolStudent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchoolStudent>>, {data: BodyType<SchoolStudentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSchoolStudent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSchoolStudentMutationResult = NonNullable<Awaited<ReturnType<typeof createSchoolStudent>>>
    export type CreateSchoolStudentMutationBody = BodyType<SchoolStudentInput>
    export type CreateSchoolStudentMutationError = ErrorType<void>

    /**
 * @summary Add a student and optional primary guardian
 */
export const useCreateSchoolStudent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolStudent>>, TError,{data: BodyType<SchoolStudentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSchoolStudent>>,
        TError,
        {data: BodyType<SchoolStudentInput>},
        TContext
      > => {
      return useMutation(getCreateSchoolStudentMutationOptions(options));
    }

export const getPreviewSchoolStudentImportUrl = () => {




  return `/api/school/students/import/preview`
}

/**
 * @summary Preview student roster rows before import
 */
export const previewSchoolStudentImport = async (schoolStudentRosterImportInput: SchoolStudentRosterImportInput, options?: RequestInit): Promise<SchoolStudentRosterPreviewResponse> => {

  return customFetch<SchoolStudentRosterPreviewResponse>(getPreviewSchoolStudentImportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolStudentRosterImportInput)
  }
);}




export const getPreviewSchoolStudentImportMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewSchoolStudentImport>>, TError,{data: BodyType<SchoolStudentRosterImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewSchoolStudentImport>>, TError,{data: BodyType<SchoolStudentRosterImportInput>}, TContext> => {

const mutationKey = ['previewSchoolStudentImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewSchoolStudentImport>>, {data: BodyType<SchoolStudentRosterImportInput>}> = (props) => {
          const {data} = props ?? {};

          return  previewSchoolStudentImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewSchoolStudentImportMutationResult = NonNullable<Awaited<ReturnType<typeof previewSchoolStudentImport>>>
    export type PreviewSchoolStudentImportMutationBody = BodyType<SchoolStudentRosterImportInput>
    export type PreviewSchoolStudentImportMutationError = ErrorType<void>

    /**
 * @summary Preview student roster rows before import
 */
export const usePreviewSchoolStudentImport = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewSchoolStudentImport>>, TError,{data: BodyType<SchoolStudentRosterImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof previewSchoolStudentImport>>,
        TError,
        {data: BodyType<SchoolStudentRosterImportInput>},
        TContext
      > => {
      return useMutation(getPreviewSchoolStudentImportMutationOptions(options));
    }

export const getImportSchoolStudentRosterUrl = () => {




  return `/api/school/students/import`
}

/**
 * @summary Import valid student roster rows
 */
export const importSchoolStudentRoster = async (schoolStudentRosterImportInput: SchoolStudentRosterImportInput, options?: RequestInit): Promise<SchoolStudentRosterImportResponse> => {

  return customFetch<SchoolStudentRosterImportResponse>(getImportSchoolStudentRosterUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolStudentRosterImportInput)
  }
);}




export const getImportSchoolStudentRosterMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importSchoolStudentRoster>>, TError,{data: BodyType<SchoolStudentRosterImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importSchoolStudentRoster>>, TError,{data: BodyType<SchoolStudentRosterImportInput>}, TContext> => {

const mutationKey = ['importSchoolStudentRoster'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importSchoolStudentRoster>>, {data: BodyType<SchoolStudentRosterImportInput>}> = (props) => {
          const {data} = props ?? {};

          return  importSchoolStudentRoster(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportSchoolStudentRosterMutationResult = NonNullable<Awaited<ReturnType<typeof importSchoolStudentRoster>>>
    export type ImportSchoolStudentRosterMutationBody = BodyType<SchoolStudentRosterImportInput>
    export type ImportSchoolStudentRosterMutationError = ErrorType<void>

    /**
 * @summary Import valid student roster rows
 */
export const useImportSchoolStudentRoster = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importSchoolStudentRoster>>, TError,{data: BodyType<SchoolStudentRosterImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importSchoolStudentRoster>>,
        TError,
        {data: BodyType<SchoolStudentRosterImportInput>},
        TContext
      > => {
      return useMutation(getImportSchoolStudentRosterMutationOptions(options));
    }

export const getGetSchoolStudentUrl = (id: number,) => {




  return `/api/school/students/${id}`
}

/**
 * @summary Get a student and linked guardians
 */
export const getSchoolStudent = async (id: number, options?: RequestInit): Promise<SchoolStudentProfile> => {

  return customFetch<SchoolStudentProfile>(getGetSchoolStudentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSchoolStudentQueryKey = (id: number,) => {
    return [
    `/api/school/students/${id}`
    ] as const;
    }


export const getGetSchoolStudentQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolStudent>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSchoolStudent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchoolStudentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolStudent>>> = ({ signal }) => getSchoolStudent(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchoolStudent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSchoolStudentQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolStudent>>>
export type GetSchoolStudentQueryError = ErrorType<void>


/**
 * @summary Get a student and linked guardians
 */

export function useGetSchoolStudent<TData = Awaited<ReturnType<typeof getSchoolStudent>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSchoolStudent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSchoolStudentQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateSchoolStudentUrl = (id: number,) => {




  return `/api/school/students/${id}`
}

/**
 * @summary Update student details or active status
 */
export const updateSchoolStudent = async (id: number,
    schoolStudentUpdate: SchoolStudentUpdate, options?: RequestInit): Promise<SchoolStudent> => {

  return customFetch<SchoolStudent>(getUpdateSchoolStudentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolStudentUpdate)
  }
);}




export const getUpdateSchoolStudentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolStudent>>, TError,{id: number;data: BodyType<SchoolStudentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSchoolStudent>>, TError,{id: number;data: BodyType<SchoolStudentUpdate>}, TContext> => {

const mutationKey = ['updateSchoolStudent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSchoolStudent>>, {id: number;data: BodyType<SchoolStudentUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSchoolStudent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSchoolStudentMutationResult = NonNullable<Awaited<ReturnType<typeof updateSchoolStudent>>>
    export type UpdateSchoolStudentMutationBody = BodyType<SchoolStudentUpdate>
    export type UpdateSchoolStudentMutationError = ErrorType<void>

    /**
 * @summary Update student details or active status
 */
export const useUpdateSchoolStudent = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolStudent>>, TError,{id: number;data: BodyType<SchoolStudentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSchoolStudent>>,
        TError,
        {id: number;data: BodyType<SchoolStudentUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSchoolStudentMutationOptions(options));
    }

export const getCreateSchoolGuardianUrl = (studentId: number,) => {




  return `/api/school/students/${studentId}/guardians`
}

/**
 * @summary Add a guardian or payer contact to a student
 */
export const createSchoolGuardian = async (studentId: number,
    schoolGuardianInput: SchoolGuardianInput, options?: RequestInit): Promise<SchoolGuardian> => {

  return customFetch<SchoolGuardian>(getCreateSchoolGuardianUrl(studentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolGuardianInput)
  }
);}




export const getCreateSchoolGuardianMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolGuardian>>, TError,{studentId: number;data: BodyType<SchoolGuardianInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSchoolGuardian>>, TError,{studentId: number;data: BodyType<SchoolGuardianInput>}, TContext> => {

const mutationKey = ['createSchoolGuardian'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchoolGuardian>>, {studentId: number;data: BodyType<SchoolGuardianInput>}> = (props) => {
          const {studentId,data} = props ?? {};

          return  createSchoolGuardian(studentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSchoolGuardianMutationResult = NonNullable<Awaited<ReturnType<typeof createSchoolGuardian>>>
    export type CreateSchoolGuardianMutationBody = BodyType<SchoolGuardianInput>
    export type CreateSchoolGuardianMutationError = ErrorType<void>

    /**
 * @summary Add a guardian or payer contact to a student
 */
export const useCreateSchoolGuardian = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolGuardian>>, TError,{studentId: number;data: BodyType<SchoolGuardianInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSchoolGuardian>>,
        TError,
        {studentId: number;data: BodyType<SchoolGuardianInput>},
        TContext
      > => {
      return useMutation(getCreateSchoolGuardianMutationOptions(options));
    }

export const getDeleteSchoolGuardianUrl = (id: number,) => {




  return `/api/school/guardians/${id}`
}

/**
 * @summary Remove a guardian contact
 */
export const deleteSchoolGuardian = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteSchoolGuardianUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSchoolGuardianMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolGuardian>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolGuardian>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteSchoolGuardian'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSchoolGuardian>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteSchoolGuardian(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSchoolGuardianMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSchoolGuardian>>>

    export type DeleteSchoolGuardianMutationError = ErrorType<void>

    /**
 * @summary Remove a guardian contact
 */
export const useDeleteSchoolGuardian = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolGuardian>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSchoolGuardian>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteSchoolGuardianMutationOptions(options));
    }

export const getListSchoolFeeSchedulesUrl = (params?: ListSchoolFeeSchedulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/school/fee-schedules?${stringifiedParams}` : `/api/school/fee-schedules`
}

/**
 * @summary List class fee schedules
 */
export const listSchoolFeeSchedules = async (params?: ListSchoolFeeSchedulesParams, options?: RequestInit): Promise<SchoolFeeSchedule[]> => {

  return customFetch<SchoolFeeSchedule[]>(getListSchoolFeeSchedulesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSchoolFeeSchedulesQueryKey = (params?: ListSchoolFeeSchedulesParams,) => {
    return [
    `/api/school/fee-schedules`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSchoolFeeSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof listSchoolFeeSchedules>>, TError = ErrorType<unknown>>(params?: ListSchoolFeeSchedulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSchoolFeeSchedules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSchoolFeeSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchoolFeeSchedules>>> = ({ signal }) => listSchoolFeeSchedules(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchoolFeeSchedules>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSchoolFeeSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof listSchoolFeeSchedules>>>
export type ListSchoolFeeSchedulesQueryError = ErrorType<unknown>


/**
 * @summary List class fee schedules
 */

export function useListSchoolFeeSchedules<TData = Awaited<ReturnType<typeof listSchoolFeeSchedules>>, TError = ErrorType<unknown>>(
 params?: ListSchoolFeeSchedulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSchoolFeeSchedules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSchoolFeeSchedulesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateSchoolFeeScheduleUrl = () => {




  return `/api/school/fee-schedules`
}

/**
 * @summary Create a class fee schedule for a term
 */
export const createSchoolFeeSchedule = async (schoolFeeScheduleInput: SchoolFeeScheduleInput, options?: RequestInit): Promise<SchoolFeeSchedule> => {

  return customFetch<SchoolFeeSchedule>(getCreateSchoolFeeScheduleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolFeeScheduleInput)
  }
);}




export const getCreateSchoolFeeScheduleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolFeeSchedule>>, TError,{data: BodyType<SchoolFeeScheduleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSchoolFeeSchedule>>, TError,{data: BodyType<SchoolFeeScheduleInput>}, TContext> => {

const mutationKey = ['createSchoolFeeSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchoolFeeSchedule>>, {data: BodyType<SchoolFeeScheduleInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSchoolFeeSchedule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSchoolFeeScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof createSchoolFeeSchedule>>>
    export type CreateSchoolFeeScheduleMutationBody = BodyType<SchoolFeeScheduleInput>
    export type CreateSchoolFeeScheduleMutationError = ErrorType<void>

    /**
 * @summary Create a class fee schedule for a term
 */
export const useCreateSchoolFeeSchedule = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolFeeSchedule>>, TError,{data: BodyType<SchoolFeeScheduleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSchoolFeeSchedule>>,
        TError,
        {data: BodyType<SchoolFeeScheduleInput>},
        TContext
      > => {
      return useMutation(getCreateSchoolFeeScheduleMutationOptions(options));
    }

export const getUpdateSchoolFeeScheduleUrl = (id: number,) => {




  return `/api/school/fee-schedules/${id}`
}

/**
 * @summary Edit a fee schedule before applying it to students
 */
export const updateSchoolFeeSchedule = async (id: number,
    schoolFeeScheduleUpdate: SchoolFeeScheduleUpdate, options?: RequestInit): Promise<SchoolFeeSchedule> => {

  return customFetch<SchoolFeeSchedule>(getUpdateSchoolFeeScheduleUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolFeeScheduleUpdate)
  }
);}




export const getUpdateSchoolFeeScheduleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolFeeSchedule>>, TError,{id: number;data: BodyType<SchoolFeeScheduleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSchoolFeeSchedule>>, TError,{id: number;data: BodyType<SchoolFeeScheduleUpdate>}, TContext> => {

const mutationKey = ['updateSchoolFeeSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSchoolFeeSchedule>>, {id: number;data: BodyType<SchoolFeeScheduleUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSchoolFeeSchedule(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSchoolFeeScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof updateSchoolFeeSchedule>>>
    export type UpdateSchoolFeeScheduleMutationBody = BodyType<SchoolFeeScheduleUpdate>
    export type UpdateSchoolFeeScheduleMutationError = ErrorType<void>

    /**
 * @summary Edit a fee schedule before applying it to students
 */
export const useUpdateSchoolFeeSchedule = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolFeeSchedule>>, TError,{id: number;data: BodyType<SchoolFeeScheduleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSchoolFeeSchedule>>,
        TError,
        {id: number;data: BodyType<SchoolFeeScheduleUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSchoolFeeScheduleMutationOptions(options));
    }

export const getApplySchoolFeeScheduleUrl = (id: number,) => {




  return `/api/school/fee-schedules/${id}/apply`
}

/**
 * @summary Apply or safely retry a class fee schedule for active students
 */
export const applySchoolFeeSchedule = async (id: number, options?: RequestInit): Promise<SchoolFeeScheduleApplyResponse> => {

  return customFetch<SchoolFeeScheduleApplyResponse>(getApplySchoolFeeScheduleUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getApplySchoolFeeScheduleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applySchoolFeeSchedule>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof applySchoolFeeSchedule>>, TError,{id: number}, TContext> => {

const mutationKey = ['applySchoolFeeSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applySchoolFeeSchedule>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  applySchoolFeeSchedule(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplySchoolFeeScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof applySchoolFeeSchedule>>>

    export type ApplySchoolFeeScheduleMutationError = ErrorType<void>

    /**
 * @summary Apply or safely retry a class fee schedule for active students
 */
export const useApplySchoolFeeSchedule = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applySchoolFeeSchedule>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof applySchoolFeeSchedule>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getApplySchoolFeeScheduleMutationOptions(options));
    }

export const getCreateSchoolFeeChargeUrl = (id: number,) => {




  return `/api/school/students/${id}/charges`
}

/**
 * @summary Add an individual fee charge to a student
 */
export const createSchoolFeeCharge = async (id: number,
    schoolFeeChargeInput: SchoolFeeChargeInput, options?: RequestInit): Promise<SchoolFeeCharge> => {

  return customFetch<SchoolFeeCharge>(getCreateSchoolFeeChargeUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolFeeChargeInput)
  }
);}




export const getCreateSchoolFeeChargeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolFeeCharge>>, TError,{id: number;data: BodyType<SchoolFeeChargeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSchoolFeeCharge>>, TError,{id: number;data: BodyType<SchoolFeeChargeInput>}, TContext> => {

const mutationKey = ['createSchoolFeeCharge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchoolFeeCharge>>, {id: number;data: BodyType<SchoolFeeChargeInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createSchoolFeeCharge(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSchoolFeeChargeMutationResult = NonNullable<Awaited<ReturnType<typeof createSchoolFeeCharge>>>
    export type CreateSchoolFeeChargeMutationBody = BodyType<SchoolFeeChargeInput>
    export type CreateSchoolFeeChargeMutationError = ErrorType<void>

    /**
 * @summary Add an individual fee charge to a student
 */
export const useCreateSchoolFeeCharge = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolFeeCharge>>, TError,{id: number;data: BodyType<SchoolFeeChargeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSchoolFeeCharge>>,
        TError,
        {id: number;data: BodyType<SchoolFeeChargeInput>},
        TContext
      > => {
      return useMutation(getCreateSchoolFeeChargeMutationOptions(options));
    }

export const getCreateSchoolFeeAdjustmentUrl = (id: number,) => {




  return `/api/school/charges/${id}/adjustments`
}

/**
 * @summary Add an auditable increase or discount to a fee charge
 */
export const createSchoolFeeAdjustment = async (id: number,
    schoolFeeAdjustmentInput: SchoolFeeAdjustmentInput, options?: RequestInit): Promise<SchoolFeeAdjustment> => {

  return customFetch<SchoolFeeAdjustment>(getCreateSchoolFeeAdjustmentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolFeeAdjustmentInput)
  }
);}




export const getCreateSchoolFeeAdjustmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolFeeAdjustment>>, TError,{id: number;data: BodyType<SchoolFeeAdjustmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSchoolFeeAdjustment>>, TError,{id: number;data: BodyType<SchoolFeeAdjustmentInput>}, TContext> => {

const mutationKey = ['createSchoolFeeAdjustment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchoolFeeAdjustment>>, {id: number;data: BodyType<SchoolFeeAdjustmentInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createSchoolFeeAdjustment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSchoolFeeAdjustmentMutationResult = NonNullable<Awaited<ReturnType<typeof createSchoolFeeAdjustment>>>
    export type CreateSchoolFeeAdjustmentMutationBody = BodyType<SchoolFeeAdjustmentInput>
    export type CreateSchoolFeeAdjustmentMutationError = ErrorType<void>

    /**
 * @summary Add an auditable increase or discount to a fee charge
 */
export const useCreateSchoolFeeAdjustment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolFeeAdjustment>>, TError,{id: number;data: BodyType<SchoolFeeAdjustmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSchoolFeeAdjustment>>,
        TError,
        {id: number;data: BodyType<SchoolFeeAdjustmentInput>},
        TContext
      > => {
      return useMutation(getCreateSchoolFeeAdjustmentMutationOptions(options));
    }

export const getCreateSchoolFeePaymentUrl = () => {




  return `/api/school/fees/payments`
}

/**
 * @summary Record and allocate a fee payment
 */
export const createSchoolFeePayment = async (schoolFeePaymentInput: SchoolFeePaymentInput, options?: RequestInit): Promise<SchoolFeePayment> => {

  return customFetch<SchoolFeePayment>(getCreateSchoolFeePaymentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolFeePaymentInput)
  }
);}




export const getCreateSchoolFeePaymentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolFeePayment>>, TError,{data: BodyType<SchoolFeePaymentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSchoolFeePayment>>, TError,{data: BodyType<SchoolFeePaymentInput>}, TContext> => {

const mutationKey = ['createSchoolFeePayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchoolFeePayment>>, {data: BodyType<SchoolFeePaymentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createSchoolFeePayment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSchoolFeePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof createSchoolFeePayment>>>
    export type CreateSchoolFeePaymentMutationBody = BodyType<SchoolFeePaymentInput>
    export type CreateSchoolFeePaymentMutationError = ErrorType<void>

    /**
 * @summary Record and allocate a fee payment
 */
export const useCreateSchoolFeePayment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolFeePayment>>, TError,{data: BodyType<SchoolFeePaymentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSchoolFeePayment>>,
        TError,
        {data: BodyType<SchoolFeePaymentInput>},
        TContext
      > => {
      return useMutation(getCreateSchoolFeePaymentMutationOptions(options));
    }

export const getGetSchoolFeeSummaryUrl = (params: GetSchoolFeeSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/school/fees/summary?${stringifiedParams}` : `/api/school/fees/summary`
}

/**
 * @summary Summarize billed, paid, and outstanding fees by term
 */
export const getSchoolFeeSummary = async (params: GetSchoolFeeSummaryParams, options?: RequestInit): Promise<SchoolFeeSummary> => {

  return customFetch<SchoolFeeSummary>(getGetSchoolFeeSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSchoolFeeSummaryQueryKey = (params?: GetSchoolFeeSummaryParams,) => {
    return [
    `/api/school/fees/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSchoolFeeSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolFeeSummary>>, TError = ErrorType<void>>(params: GetSchoolFeeSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSchoolFeeSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchoolFeeSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolFeeSummary>>> = ({ signal }) => getSchoolFeeSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchoolFeeSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSchoolFeeSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolFeeSummary>>>
export type GetSchoolFeeSummaryQueryError = ErrorType<void>


/**
 * @summary Summarize billed, paid, and outstanding fees by term
 */

export function useGetSchoolFeeSummary<TData = Awaited<ReturnType<typeof getSchoolFeeSummary>>, TError = ErrorType<void>>(
 params: GetSchoolFeeSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSchoolFeeSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSchoolFeeSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetSchoolFeeReminderSettingsUrl = () => {




  return `/api/school/fees/reminder-settings`
}

/**
 * @summary Get school fee reminder timing
 */
export const getSchoolFeeReminderSettings = async ( options?: RequestInit): Promise<SchoolFeeReminderSettings> => {

  return customFetch<SchoolFeeReminderSettings>(getGetSchoolFeeReminderSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSchoolFeeReminderSettingsQueryKey = () => {
    return [
    `/api/school/fees/reminder-settings`
    ] as const;
    }


export const getGetSchoolFeeReminderSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolFeeReminderSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSchoolFeeReminderSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchoolFeeReminderSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolFeeReminderSettings>>> = ({ signal }) => getSchoolFeeReminderSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchoolFeeReminderSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSchoolFeeReminderSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolFeeReminderSettings>>>
export type GetSchoolFeeReminderSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get school fee reminder timing
 */

export function useGetSchoolFeeReminderSettings<TData = Awaited<ReturnType<typeof getSchoolFeeReminderSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSchoolFeeReminderSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSchoolFeeReminderSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateSchoolFeeReminderSettingsUrl = () => {




  return `/api/school/fees/reminder-settings`
}

/**
 * @summary Update school fee reminder timing
 */
export const updateSchoolFeeReminderSettings = async (schoolFeeReminderSettingsInput: SchoolFeeReminderSettingsInput, options?: RequestInit): Promise<SchoolFeeReminderSettings> => {

  return customFetch<SchoolFeeReminderSettings>(getUpdateSchoolFeeReminderSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schoolFeeReminderSettingsInput)
  }
);}




export const getUpdateSchoolFeeReminderSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolFeeReminderSettings>>, TError,{data: BodyType<SchoolFeeReminderSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSchoolFeeReminderSettings>>, TError,{data: BodyType<SchoolFeeReminderSettingsInput>}, TContext> => {

const mutationKey = ['updateSchoolFeeReminderSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSchoolFeeReminderSettings>>, {data: BodyType<SchoolFeeReminderSettingsInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateSchoolFeeReminderSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSchoolFeeReminderSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSchoolFeeReminderSettings>>>
    export type UpdateSchoolFeeReminderSettingsMutationBody = BodyType<SchoolFeeReminderSettingsInput>
    export type UpdateSchoolFeeReminderSettingsMutationError = ErrorType<void>

    /**
 * @summary Update school fee reminder timing
 */
export const useUpdateSchoolFeeReminderSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolFeeReminderSettings>>, TError,{data: BodyType<SchoolFeeReminderSettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSchoolFeeReminderSettings>>,
        TError,
        {data: BodyType<SchoolFeeReminderSettingsInput>},
        TContext
      > => {
      return useMutation(getUpdateSchoolFeeReminderSettingsMutationOptions(options));
    }

export const getListSchoolFeeRemindersUrl = (params: ListSchoolFeeRemindersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/school/fees/reminders?${stringifiedParams}` : `/api/school/fees/reminders`
}

/**
 * @summary List eligible upcoming and overdue fee reminders
 */
export const listSchoolFeeReminders = async (params: ListSchoolFeeRemindersParams, options?: RequestInit): Promise<SchoolFeeReminderList> => {

  return customFetch<SchoolFeeReminderList>(getListSchoolFeeRemindersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSchoolFeeRemindersQueryKey = (params?: ListSchoolFeeRemindersParams,) => {
    return [
    `/api/school/fees/reminders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSchoolFeeRemindersQueryOptions = <TData = Awaited<ReturnType<typeof listSchoolFeeReminders>>, TError = ErrorType<void>>(params: ListSchoolFeeRemindersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSchoolFeeReminders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSchoolFeeRemindersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchoolFeeReminders>>> = ({ signal }) => listSchoolFeeReminders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchoolFeeReminders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSchoolFeeRemindersQueryResult = NonNullable<Awaited<ReturnType<typeof listSchoolFeeReminders>>>
export type ListSchoolFeeRemindersQueryError = ErrorType<void>


/**
 * @summary List eligible upcoming and overdue fee reminders
 */

export function useListSchoolFeeReminders<TData = Awaited<ReturnType<typeof listSchoolFeeReminders>>, TError = ErrorType<void>>(
 params: ListSchoolFeeRemindersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSchoolFeeReminders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSchoolFeeRemindersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSendSchoolFeeReminderUrl = (chargeId: number,) => {




  return `/api/school/fees/reminders/${chargeId}/send`
}

/**
 * @summary Send an email reminder to saved guardian email contacts for one charge
 */
export const sendSchoolFeeReminder = async (chargeId: number, options?: RequestInit): Promise<SchoolFeeReminderSendResult> => {

  return customFetch<SchoolFeeReminderSendResult>(getSendSchoolFeeReminderUrl(chargeId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSendSchoolFeeReminderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSchoolFeeReminder>>, TError,{chargeId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendSchoolFeeReminder>>, TError,{chargeId: number}, TContext> => {

const mutationKey = ['sendSchoolFeeReminder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendSchoolFeeReminder>>, {chargeId: number}> = (props) => {
          const {chargeId} = props ?? {};

          return  sendSchoolFeeReminder(chargeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendSchoolFeeReminderMutationResult = NonNullable<Awaited<ReturnType<typeof sendSchoolFeeReminder>>>

    export type SendSchoolFeeReminderMutationError = ErrorType<void>

    /**
 * @summary Send an email reminder to saved guardian email contacts for one charge
 */
export const useSendSchoolFeeReminder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSchoolFeeReminder>>, TError,{chargeId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendSchoolFeeReminder>>,
        TError,
        {chargeId: number},
        TContext
      > => {
      return useMutation(getSendSchoolFeeReminderMutationOptions(options));
    }

export const getGetSchoolStudentStatementUrl = (termId: number,
    id: number,) => {




  return `/api/school/terms/${termId}/students/${id}/statement`
}

/**
 * @summary Get a student account statement for one term
 */
export const getSchoolStudentStatement = async (termId: number,
    id: number, options?: RequestInit): Promise<SchoolFeeStatement> => {

  return customFetch<SchoolFeeStatement>(getGetSchoolStudentStatementUrl(termId,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSchoolStudentStatementQueryKey = (termId: number,
    id: number,) => {
    return [
    `/api/school/terms/${termId}/students/${id}/statement`
    ] as const;
    }


export const getGetSchoolStudentStatementQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolStudentStatement>>, TError = ErrorType<void>>(termId: number,
    id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSchoolStudentStatement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSchoolStudentStatementQueryKey(termId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolStudentStatement>>> = ({ signal }) => getSchoolStudentStatement(termId,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: termId !== null && termId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchoolStudentStatement>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSchoolStudentStatementQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolStudentStatement>>>
export type GetSchoolStudentStatementQueryError = ErrorType<void>


/**
 * @summary Get a student account statement for one term
 */

export function useGetSchoolStudentStatement<TData = Awaited<ReturnType<typeof getSchoolStudentStatement>>, TError = ErrorType<void>>(
 termId: number,
    id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSchoolStudentStatement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSchoolStudentStatementQueryOptions(termId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







